import type { KnowledgeItem } from '../types';

export const builtinCharacterExtraKnowledge: KnowledgeItem[] = [
  {
    id: "builtin-char-1001",
    type: "character",
    title: "雪",
    content: "雪",
    pronunciation: "xuě",
    meaning: "从天上落下的白色结晶物，它是高空水汽在摄氏零度以下凝结而成的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1002",
    type: "character",
    title: "午",
    content: "午",
    pronunciation: "wǔ",
    meaning: "地支的第七位，也用作次序第七",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1003",
    type: "character",
    title: "练",
    content: "练",
    pronunciation: "liàn",
    meaning: "白色的熟绢江平如",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1004",
    type: "character",
    title: "迫",
    content: "迫",
    pronunciation: "pò",
    meaning: "又如迫措(犹逼近)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1005",
    type: "character",
    title: "爷",
    content: "爷",
    pronunciation: "yé",
    meaning: "〈古〉同\"耶\"，父亲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1006",
    type: "character",
    title: "篇",
    content: "篇",
    pronunciation: "piān",
    meaning: "首尾完整的文章著作短",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1007",
    type: "character",
    title: "肉",
    content: "肉",
    pronunciation: "ròu",
    meaning: "人或动物附着在骨骼上的柔软物质肌",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1008",
    type: "character",
    title: "嘴",
    content: "嘴",
    pronunciation: "zuǐ",
    meaning: "口含在",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1009",
    type: "character",
    title: "馆",
    content: "馆",
    pronunciation: "ɡuǎn",
    meaning: "接待宾客或旅客居住或食宿的房屋宾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1010",
    type: "character",
    title: "遍",
    content: "遍",
    pronunciation: "biàn",
    meaning: "泛指普遍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1011",
    type: "character",
    title: "凡",
    content: "凡",
    pronunciation: "fán",
    meaning: "所有的，总共，总计",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1012",
    type: "character",
    title: "础",
    content: "础",
    pronunciation: "chǔ",
    meaning: "又如础石;",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1013",
    type: "character",
    title: "洞",
    content: "洞",
    pronunciation: "dònɡ",
    meaning: "窟窿;孔穴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1014",
    type: "character",
    title: "卷",
    content: "卷",
    pronunciation: "juàn",
    meaning: "将东西弯曲裹成圆筒形",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1015",
    type: "character",
    title: "坦",
    content: "坦",
    pronunciation: "tǎn",
    meaning: "平直，宽广",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1016",
    type: "character",
    title: "牛",
    content: "牛",
    pronunciation: "niú",
    meaning: "家畜，反刍类动物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1017",
    type: "character",
    title: "宁",
    content: "宁",
    pronunciation: "nínɡ",
    meaning: "安定，平安",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1018",
    type: "character",
    title: "纸",
    content: "纸",
    pronunciation: "zhǐ",
    meaning: "用于书写、印刷、绘画、包装等的东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1019",
    type: "character",
    title: "诸",
    content: "诸",
    pronunciation: "zhū",
    meaning: "各，众，许多",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1020",
    type: "character",
    title: "训",
    content: "训",
    pronunciation: "xùn",
    meaning: "教导，教诲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1021",
    type: "character",
    title: "私",
    content: "私",
    pronunciation: "sī",
    meaning: "个人的，跟\"公\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1022",
    type: "character",
    title: "庄",
    content: "庄",
    pronunciation: "zhuānɡ",
    meaning: "严肃，端重",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1023",
    type: "character",
    title: "祖",
    content: "祖",
    pronunciation: "zǔ",
    meaning: "父母的上一辈",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1024",
    type: "character",
    title: "丝",
    content: "丝",
    pronunciation: "sī",
    meaning: "蚕吐出的纤维",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1025",
    type: "character",
    title: "翻",
    content: "翻",
    pronunciation: "fān",
    meaning: "反转，歪倒，上下、内外移位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1026",
    type: "character",
    title: "暴",
    content: "暴",
    pronunciation: "bào",
    meaning: "晒冬",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1027",
    type: "character",
    title: "森",
    content: "森",
    pronunciation: "sēn",
    meaning: "树木多而且密",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1028",
    type: "character",
    title: "塔",
    content: "塔",
    pronunciation: "tǎ",
    meaning: "佛教特有的一种尖顶高耸建筑物大雁",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1029",
    type: "character",
    title: "默",
    content: "默",
    pronunciation: "mò",
    meaning: "闭口不说话",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1030",
    type: "character",
    title: "握",
    content: "握",
    pronunciation: "wò",
    meaning: "拿住，抓在手里",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1031",
    type: "character",
    title: "戏",
    content: "戏",
    pronunciation: "xì",
    meaning: "假借为麾。军队中的帅旗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1032",
    type: "character",
    title: "隐",
    content: "隐",
    pronunciation: "yǐn",
    meaning: "藏匿，潜伏，不显露",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1033",
    type: "character",
    title: "熟",
    content: "熟",
    pronunciation: "shú",
    meaning: "烹饪食物达到可吃程度",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1034",
    type: "character",
    title: "骨",
    content: "骨",
    pronunciation: "ɡǔ",
    meaning: "排球在地上骨碌",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1035",
    type: "character",
    title: "访",
    content: "访",
    pronunciation: "fǎnɡ",
    meaning: "询问，调查",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1036",
    type: "character",
    title: "弱",
    content: "弱",
    pronunciation: "ruò",
    meaning: "力小，势差，跟\"强\"相对体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1037",
    type: "character",
    title: "蒙",
    content: "蒙",
    pronunciation: "ménɡ",
    meaning: "欺骗莫",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1038",
    type: "character",
    title: "歌",
    content: "歌",
    pronunciation: "ɡē",
    meaning: "能唱的诗、词语诗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1039",
    type: "character",
    title: "店",
    content: "店",
    pronunciation: "diàn",
    meaning: "旅舍;客店",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1040",
    type: "character",
    title: "鬼",
    content: "鬼",
    pronunciation: "ɡuǐ",
    meaning: "迷信者认为\"人死后有灵魂\"叫\"鬼\"没有",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1041",
    type: "character",
    title: "软",
    content: "软",
    pronunciation: "ruǎn",
    meaning: "柔，跟\"硬\"相对柔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1042",
    type: "character",
    title: "典",
    content: "典",
    pronunciation: "diǎn",
    meaning: "又如药典;字典;释典(佛经);法典;佛典;引经据典;典志(记",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1043",
    type: "character",
    title: "欲",
    content: "欲",
    pronunciation: "yù",
    meaning: "想要，想得到，想达到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1044",
    type: "character",
    title: "萨",
    content: "萨",
    pronunciation: "sà",
    meaning: "佛教用语,即菩萨",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1045",
    type: "character",
    title: "伙",
    content: "伙",
    pronunciation: "huǒ",
    meaning: "同伴，伴侣，一同做事的人同",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1046",
    type: "character",
    title: "遭",
    content: "遭",
    pronunciation: "zāo",
    meaning: "逢，遇，碰到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1047",
    type: "character",
    title: "盘",
    content: "盘",
    pronunciation: "pán",
    meaning: "扁而浅的盛器钢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1048",
    type: "character",
    title: "爸",
    content: "爸",
    pronunciation: "bà",
    meaning: "又如爸爸(父亲);阿爸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1049",
    type: "character",
    title: "扩",
    content: "扩",
    pronunciation: "kuò",
    meaning: "又如扩清(廓清;肃清);扩广(扩张。犹扩大)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1050",
    type: "character",
    title: "盖",
    content: "盖",
    pronunciation: "ɡài",
    meaning: "遮蔽器物的东西茶杯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1051",
    type: "character",
    title: "弄",
    content: "弄",
    pronunciation: "nònɡ",
    meaning: "〈方〉小巷，胡同",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1052",
    type: "character",
    title: "雄",
    content: "雄",
    pronunciation: "xiónɡ",
    meaning: "公的，跟\"雌\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1053",
    type: "character",
    title: "稳",
    content: "稳",
    pronunciation: "wěn",
    meaning: "安定，固定，不动摇",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1054",
    type: "character",
    title: "忘",
    content: "忘",
    pronunciation: "wànɡ",
    meaning: "不记得",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1055",
    type: "character",
    title: "亿",
    content: "亿",
    pronunciation: "yì",
    meaning: "安宁;安定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1056",
    type: "character",
    title: "刺",
    content: "刺",
    pronunciation: "cì",
    meaning: "激烈的撞击或爆炸声",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1057",
    type: "character",
    title: "拥",
    content: "拥",
    pronunciation: "yōnɡ",
    meaning: "抱，持",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1058",
    type: "character",
    title: "徒",
    content: "徒",
    pronunciation: "tú",
    meaning: "步行",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1059",
    type: "character",
    title: "姆",
    content: "姆",
    pronunciation: "mǔ",
    meaning: "①古代教育未出嫁女子的妇人。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1060",
    type: "character",
    title: "杨",
    content: "杨",
    pronunciation: "yánɡ",
    meaning: "比海更大的水域太平",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1061",
    type: "character",
    title: "齐",
    content: "齐",
    pronunciation: "qí",
    meaning: "一致，不乱，一同，等同",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1062",
    type: "character",
    title: "赛",
    content: "赛",
    pronunciation: "sài",
    meaning: "比较好坏、强弱、胜负比",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1063",
    type: "character",
    title: "趣",
    content: "趣",
    pronunciation: "qù",
    meaning: "趋向，意向，奔赴志",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1064",
    type: "character",
    title: "曲",
    content: "曲",
    pronunciation: "qǔ",
    meaning: "文体名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1065",
    type: "character",
    title: "刀",
    content: "刀",
    pronunciation: "dāo",
    meaning: "又如刀枪;刀兵;刀瘢(刀伤的褊)。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1066",
    type: "character",
    title: "床",
    content: "床",
    pronunciation: "chuánɡ",
    meaning: "供人睡觉的家具木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1067",
    type: "character",
    title: "迎",
    content: "迎",
    pronunciation: "yínɡ",
    meaning: "接，热情接待",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1068",
    type: "character",
    title: "冰",
    content: "冰",
    pronunciation: "bīnɡ",
    meaning: "的会意字,于是仌就专用作部首。本义水冻结而成的固体)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1069",
    type: "character",
    title: "虚",
    content: "虚",
    pronunciation: "xū",
    meaning: "空，跟\"实\"相对空",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1070",
    type: "character",
    title: "玩",
    content: "玩",
    pronunciation: "wán",
    meaning: "游戏，做某种游戏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1071",
    type: "character",
    title: "析",
    content: "析",
    pronunciation: "xī",
    meaning: "分开，散开条分缕",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1072",
    type: "character",
    title: "窗",
    content: "窗",
    pronunciation: "chuānɡ",
    meaning: "同本义。也作囱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1073",
    type: "character",
    title: "醒",
    content: "醒",
    pronunciation: "xǐnɡ",
    meaning: "睡完觉或未睡着睡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1074",
    type: "character",
    title: "妻",
    content: "妻",
    pronunciation: "qī",
    meaning: "天子有妻、有妾。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1075",
    type: "character",
    title: "透",
    content: "透",
    pronunciation: "tòu",
    meaning: "穿过，通过",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1076",
    type: "character",
    title: "购",
    content: "购",
    pronunciation: "ɡòu",
    meaning: "又如购求(设置奖金以捉捕犯人);购问(悬赏征询);购募(悬赏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1077",
    type: "character",
    title: "替",
    content: "替",
    pronunciation: "tì",
    meaning: "代，代理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1078",
    type: "character",
    title: "塞",
    content: "塞",
    pronunciation: "sāi",
    meaning: "堵，堵住堵",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1079",
    type: "character",
    title: "努",
    content: "努",
    pronunciation: "nǔ",
    meaning: "尽力，尽量使出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1080",
    type: "character",
    title: "休",
    content: "休",
    pronunciation: "xiū",
    meaning: "歇息，养息",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1081",
    type: "character",
    title: "虎",
    content: "虎",
    pronunciation: "hǔ",
    meaning: "通称老虎",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1082",
    type: "character",
    title: "扬",
    content: "扬",
    pronunciation: "yánɡ",
    meaning: "举起，高举",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1083",
    type: "character",
    title: "途",
    content: "途",
    pronunciation: "tú",
    meaning: "道路",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1084",
    type: "character",
    title: "侵",
    content: "侵",
    pronunciation: "qīn",
    meaning: "进犯，欺负",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1085",
    type: "character",
    title: "刑",
    content: "刑",
    pronunciation: "xínɡ",
    meaning: "刑罚，对犯人各种处罚的总称定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1086",
    type: "character",
    title: "绿",
    content: "绿",
    pronunciation: "lǜ",
    meaning: "一般草和树叶的颜色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1087",
    type: "character",
    title: "兄",
    content: "兄",
    pronunciation: "xiōnɡ",
    meaning: "哥哥吾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1088",
    type: "character",
    title: "迅",
    content: "迅",
    pronunciation: "xùn",
    meaning: "又如迅指(巡指间。弹指间);迅羽(形容快飞的鸟);迅走(走得",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1089",
    type: "character",
    title: "套",
    content: "套",
    pronunciation: "tào",
    meaning: "加罩，罩在外面的东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1090",
    type: "character",
    title: "贸",
    content: "贸",
    pronunciation: "mào",
    meaning: "交易，交换财物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1091",
    type: "character",
    title: "毕",
    content: "毕",
    pronunciation: "bì",
    meaning: "又如毕戈(毕为捕兽所用之网,戈为射鸟所用的系绳之箭。泛指打猎",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1092",
    type: "character",
    title: "唯",
    content: "唯",
    pronunciation: "wéi",
    meaning: "应答声",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1093",
    type: "character",
    title: "谷",
    content: "谷",
    pronunciation: "ɡǔ",
    meaning: "庄稼和粮食的总称种",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1094",
    type: "character",
    title: "轮",
    content: "轮",
    pronunciation: "lún",
    meaning: "安在车上、机器上，能旋转并促使车、机器动作的东西车",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1095",
    type: "character",
    title: "库",
    content: "库",
    pronunciation: "kù",
    meaning: "贮藏东西的地方或建筑物仓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1096",
    type: "character",
    title: "迹",
    content: "迹",
    pronunciation: "jì",
    meaning: "脚印留有足",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1097",
    type: "character",
    title: "尤",
    content: "尤",
    pronunciation: "yóu",
    meaning: "更，特别，格外",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1098",
    type: "character",
    title: "竞",
    content: "竞",
    pronunciation: "jìnɡ",
    meaning: "争逐，比赛，互相争胜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1099",
    type: "character",
    title: "街",
    content: "街",
    pronunciation: "jiē",
    meaning: "城市的大道,两边有房屋的、比较宽阔的道路,通常指开设商店的区",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1100",
    type: "character",
    title: "促",
    content: "促",
    pronunciation: "cù",
    meaning: "又如促柱(急切的絣音);促装(急忙整治行装);促速(急速);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1101",
    type: "character",
    title: "延",
    content: "延",
    pronunciation: "yán",
    meaning: "伸长，扩展",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1102",
    type: "character",
    title: "震",
    content: "震",
    pronunciation: "zhèn",
    meaning: "疾雷（霹雳）使物体振动～夷伯之庙。～霆。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1103",
    type: "character",
    title: "弃",
    content: "弃",
    pronunciation: "qì",
    meaning: "扔掉;抛弃)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1104",
    type: "character",
    title: "甲",
    content: "甲",
    pronunciation: "jiǎ",
    meaning: "天干的第一位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1105",
    type: "character",
    title: "伟",
    content: "伟",
    pronunciation: "wěi",
    meaning: "抱负有作为的男子汉;身体魁梧的男子)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1106",
    type: "character",
    title: "麻",
    content: "麻",
    pronunciation: "má",
    meaning: "蔴、",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1107",
    type: "character",
    title: "川",
    content: "川",
    pronunciation: "chuān",
    meaning: "水道，河流",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1108",
    type: "character",
    title: "申",
    content: "申",
    pronunciation: "shēn",
    meaning: "地支的第九位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1109",
    type: "character",
    title: "缓",
    content: "缓",
    pronunciation: "huǎn",
    meaning: "慢，跟\"急\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1110",
    type: "character",
    title: "潜",
    content: "潜",
    pronunciation: "qián",
    meaning: "在水面之下活动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1111",
    type: "character",
    title: "闪",
    content: "闪",
    pronunciation: "shǎn",
    meaning: "天空的电光",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1112",
    type: "character",
    title: "售",
    content: "售",
    pronunciation: "shòu",
    meaning: "又如售卖(卖出;出售)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1113",
    type: "character",
    title: "灯",
    content: "灯",
    pronunciation: "dēnɡ",
    meaning: "同本义。亦指通电发光的照明器具或做其他用途的发光器具",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1114",
    type: "character",
    title: "针",
    content: "针",
    pronunciation: "zhēn",
    meaning: "缝、补衣物时引线用的一种细长的工具缝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1115",
    type: "character",
    title: "哲",
    content: "哲",
    pronunciation: "zhé",
    meaning: "聪明，有才能，智慧卓越的人贤",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1116",
    type: "character",
    title: "络",
    content: "络",
    pronunciation: "luò",
    meaning: "网状的东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1117",
    type: "character",
    title: "抵",
    content: "抵",
    pronunciation: "dǐ",
    meaning: "又如抵掎(排挤攻击);抵斥(排斥);抵排(排斥;抵触)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1118",
    type: "character",
    title: "朱",
    content: "朱",
    pronunciation: "zhū",
    meaning: "大红色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1119",
    type: "character",
    title: "埃",
    content: "埃",
    pronunciation: "āi",
    meaning: "又如埃尘(飞扬的尘土);埃垢(灰尘污垢);埃土(泥土,尘土)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1120",
    type: "character",
    title: "抱",
    content: "抱",
    pronunciation: "bào",
    meaning: "①用手臂围住妈妈～着孩子。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1121",
    type: "character",
    title: "鼓",
    content: "鼓",
    pronunciation: "ɡǔ",
    meaning: "一种击打乐器，多为圆柱形，中空，两头蒙皮战",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1122",
    type: "character",
    title: "植",
    content: "植",
    pronunciation: "zhí",
    meaning: "栽种种",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1123",
    type: "character",
    title: "纯",
    content: "纯",
    pronunciation: "chún",
    meaning: "〈古〉指丝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1124",
    type: "character",
    title: "夏",
    content: "夏",
    pronunciation: "xià",
    meaning: "一年四季里的第二季",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1125",
    type: "character",
    title: "忍",
    content: "忍",
    pronunciation: "rěn",
    meaning: "耐，抑制，感情不让表现出来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1126",
    type: "character",
    title: "页",
    content: "页",
    pronunciation: "yè",
    meaning: "单篇，单张活",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1127",
    type: "character",
    title: "杰",
    content: "杰",
    pronunciation: "jié",
    meaning: "才能出众的人豪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1128",
    type: "character",
    title: "筑",
    content: "筑",
    pronunciation: "zhù",
    meaning: "捣土使坚实",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1129",
    type: "character",
    title: "折",
    content: "折",
    pronunciation: "shé",
    meaning: "断树枝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1130",
    type: "character",
    title: "郑",
    content: "郑",
    pronunciation: "zhènɡ",
    meaning: "周代诸侯国名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1131",
    type: "character",
    title: "贝",
    content: "贝",
    pronunciation: "bèi",
    meaning: "古代货币",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1132",
    type: "character",
    title: "尊",
    content: "尊",
    pronunciation: "zūn",
    meaning: "敬重",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1133",
    type: "character",
    title: "吴",
    content: "吴",
    pronunciation: "wú",
    meaning: "〈古〉大声说话不",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1134",
    type: "character",
    title: "秀",
    content: "秀",
    pronunciation: "xiù",
    meaning: "谷物或植物吐穗开花麦苗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1135",
    type: "character",
    title: "混",
    content: "混",
    pronunciation: "hùn",
    meaning: "又如混沦(水旋转的样子);混澒(水流漫涌回旋的样子);混瀥(",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1136",
    type: "character",
    title: "臣",
    content: "臣",
    pronunciation: "chén",
    meaning: "奴隶社会称男性奴隶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1137",
    type: "character",
    title: "雅",
    content: "雅",
    pronunciation: "yǎ",
    meaning: "正确的，规范的察纳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1138",
    type: "character",
    title: "振",
    content: "振",
    pronunciation: "zhèn",
    meaning: "挥动，抖动，摇动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1139",
    type: "character",
    title: "染",
    content: "染",
    pronunciation: "rǎn",
    meaning: "使着色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1140",
    type: "character",
    title: "盛",
    content: "盛",
    pronunciation: "shènɡ",
    meaning: "容纳，将东西放入这车可",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1141",
    type: "character",
    title: "怒",
    content: "怒",
    pronunciation: "nù",
    meaning: "生气，气愤",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1142",
    type: "character",
    title: "舞",
    content: "舞",
    pronunciation: "wǔ",
    meaning: "按一定的节奏转动身体，作出各种姿势的表演跳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1143",
    type: "character",
    title: "圆",
    content: "圆",
    pronunciation: "yuán",
    meaning: "在平面上，定点和定距离的动点之轨迹的称谓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1144",
    type: "character",
    title: "搞",
    content: "搞",
    pronunciation: "ɡǎo",
    meaning: "形声。从手,高声。本义做,干,办,弄",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1145",
    type: "character",
    title: "狂",
    content: "狂",
    pronunciation: "kuánɡ",
    meaning: "疯癲，精神失常疯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1146",
    type: "character",
    title: "措",
    content: "措",
    pronunciation: "cuò",
    meaning: "处理,安排",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1147",
    type: "character",
    title: "姓",
    content: "姓",
    pronunciation: "xìnɡ",
    meaning: "又如姓族(大族,望族);姓字(姓氏和名字);姓系(姓氏家族的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1148",
    type: "character",
    title: "残",
    content: "残",
    pronunciation: "cán",
    meaning: "又如摧残(使蒙受严重损失);残心(残害人的心);残贼(杀害)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1149",
    type: "character",
    title: "秋",
    content: "秋",
    pronunciation: "qiū",
    meaning: "一年四季中的第三季",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1150",
    type: "character",
    title: "培",
    content: "培",
    pronunciation: "péi",
    meaning: "在植物、墙堤等的根基部分加土",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1151",
    type: "character",
    title: "迷",
    content: "迷",
    pronunciation: "mí",
    meaning: "分辨不清",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1152",
    type: "character",
    title: "诚",
    content: "诚",
    pronunciation: "chénɡ",
    meaning: "真心，不虚伪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1153",
    type: "character",
    title: "宽",
    content: "宽",
    pronunciation: "kuān",
    meaning: "阔大，跟\"窄\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1154",
    type: "character",
    title: "宇",
    content: "宇",
    pronunciation: "yǔ",
    meaning: "屋檐屋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1155",
    type: "character",
    title: "猛",
    content: "猛",
    pronunciation: "měnɡ",
    meaning: "力量大，气势壮力",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1156",
    type: "character",
    title: "摆",
    content: "摆",
    pronunciation: "bǎi",
    meaning: "又如摆落(摆脱)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1157",
    type: "character",
    title: "梅",
    content: "梅",
    pronunciation: "méi",
    meaning: "落叶乔木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1158",
    type: "character",
    title: "毁",
    content: "毁",
    pronunciation: "huǐ",
    meaning: "爏、",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1159",
    type: "character",
    title: "伸",
    content: "伸",
    pronunciation: "shēn",
    meaning: "舒展",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1160",
    type: "character",
    title: "摩",
    content: "摩",
    pronunciation: "mó",
    meaning: "摸，擦，接触按",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1161",
    type: "character",
    title: "盟",
    content: "盟",
    pronunciation: "ménɡ",
    meaning: "国与国或阶级与阶级的联合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1162",
    type: "character",
    title: "末",
    content: "末",
    pronunciation: "mò",
    meaning: "梢，尖端，跟\"本\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1163",
    type: "character",
    title: "乃",
    content: "乃",
    pronunciation: "nǎi",
    meaning: "你，你的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1164",
    type: "character",
    title: "悲",
    content: "悲",
    pronunciation: "bēi",
    meaning: "又如悲怆(悲伤);悲怨(悲痛怨恨);悲惋(悲伤惋惜);悲吟(",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1165",
    type: "character",
    title: "拍",
    content: "拍",
    pronunciation: "pāi",
    meaning: "用手掌打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1166",
    type: "character",
    title: "丁",
    content: "丁",
    pronunciation: "dīnɡ",
    meaning: "同本义。丁为钉的古字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1167",
    type: "character",
    title: "赵",
    content: "赵",
    pronunciation: "zhào",
    meaning: "字亦作踴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1168",
    type: "character",
    title: "硬",
    content: "硬",
    pronunciation: "yìnɡ",
    meaning: "坚，坚固，跟\"软\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1169",
    type: "character",
    title: "麦",
    content: "麦",
    pronunciation: "mài",
    meaning: "造纸原料",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1170",
    type: "character",
    title: "蒋",
    content: "蒋",
    pronunciation: "jiǎnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1171",
    type: "character",
    title: "操",
    content: "操",
    pronunciation: "cāo",
    meaning: "又如可操左券;同室操戈(兄弟相残或内部纷争);操刀(持刀;执",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1172",
    type: "character",
    title: "耶",
    content: "耶",
    pronunciation: "yē",
    meaning: "文言助词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1173",
    type: "character",
    title: "阻",
    content: "阻",
    pronunciation: "zǔ",
    meaning: "险要的地方，路难走",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1174",
    type: "character",
    title: "订",
    content: "订",
    pronunciation: "dìnɡ",
    meaning: "改正,修正",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1175",
    type: "character",
    title: "彩",
    content: "彩",
    pronunciation: "cǎi",
    meaning: "又如彩仗(彩饰的仪仗);剪彩;张灯结彩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1176",
    type: "character",
    title: "抽",
    content: "抽",
    pronunciation: "chōu",
    meaning: "拔出，取出，提出一部分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1177",
    type: "character",
    title: "赞",
    content: "赞",
    pronunciation: "zàn",
    meaning: "辅佐，帮助",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1178",
    type: "character",
    title: "魔",
    content: "魔",
    pronunciation: "mó",
    meaning: "迷信者所谓\"能迷惑人、伤害人的鬼怪\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1179",
    type: "character",
    title: "纷",
    content: "纷",
    pronunciation: "fēn",
    meaning: "众多，杂乱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1180",
    type: "character",
    title: "沿",
    content: "沿",
    pronunciation: "yán",
    meaning: "顺着，照着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1181",
    type: "character",
    title: "喊",
    content: "喊",
    pronunciation: "hǎn",
    meaning: "大声呼叫",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1182",
    type: "character",
    title: "违",
    content: "违",
    pronunciation: "wéi",
    meaning: "背，反，不遵守",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1183",
    type: "character",
    title: "妹",
    content: "妹",
    pronunciation: "mèi",
    meaning: "称同父母比自己年龄小的女子么",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1184",
    type: "character",
    title: "浪",
    content: "浪",
    pronunciation: "lànɡ",
    meaning: "大波波",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1185",
    type: "character",
    title: "汇",
    content: "汇",
    pronunciation: "huì",
    meaning: "用外币或本国货币兑换的票据",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1186",
    type: "character",
    title: "币",
    content: "币",
    pronunciation: "bì",
    meaning: "泛指车马皮帛玉器等礼物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1187",
    type: "character",
    title: "丰",
    content: "丰",
    pronunciation: "fēnɡ",
    meaning: "豷） fēng",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1188",
    type: "character",
    title: "蓝",
    content: "蓝",
    pronunciation: "lán",
    meaning: "蓝色，像晴空那样的颜色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1189",
    type: "character",
    title: "殊",
    content: "殊",
    pronunciation: "shū",
    meaning: "死，断，绝不",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1190",
    type: "character",
    title: "献",
    content: "献",
    pronunciation: "xiàn",
    meaning: "恭敬、庄严地送给",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1191",
    type: "character",
    title: "桌",
    content: "桌",
    pronunciation: "zhuō",
    meaning: "常用的一种家具，可在上面放东西书",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1192",
    type: "character",
    title: "啦",
    content: "啦",
    pronunciation: "lā",
    meaning: "同拉。闲扯,闲谈",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1193",
    type: "character",
    title: "瓦",
    content: "瓦",
    pronunciation: "wǎ",
    meaning: "覆盖屋顶的东西，多用陶土烧成，也有用塑料、石棉、水泥等制成的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1194",
    type: "character",
    title: "莱",
    content: "莱",
    pronunciation: "lái",
    meaning: "草名,又名藜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1195",
    type: "character",
    title: "援",
    content: "援",
    pronunciation: "yuán",
    meaning: "拉，拽，牵引攀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1196",
    type: "character",
    title: "译",
    content: "译",
    pronunciation: "yì",
    meaning: "又如汉语被译成日语;译品(翻译的作品);译义(意译);译写(",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1197",
    type: "character",
    title: "夺",
    content: "夺",
    pronunciation: "duó",
    meaning: "①强取。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1198",
    type: "character",
    title: "汽",
    content: "汽",
    pronunciation: "qì",
    meaning: "固体或液体变成的气体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1199",
    type: "character",
    title: "烧",
    content: "烧",
    pronunciation: "shāo",
    meaning: "使物体着火",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1200",
    type: "character",
    title: "距",
    content: "距",
    pronunciation: "jù",
    meaning: "距离，离开两地相",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1201",
    type: "character",
    title: "裁",
    content: "裁",
    pronunciation: "cái",
    meaning: "又如套裁;剪裁;对裁;裁衣(裁剪衣料制作衣服)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1202",
    type: "character",
    title: "偏",
    content: "偏",
    pronunciation: "piān",
    meaning: "歪，跟\"正\"相对坐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1203",
    type: "character",
    title: "符",
    content: "符",
    pronunciation: "fú",
    meaning: "〈古〉朝廷传达命令或调兵遣将的凭证",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1204",
    type: "character",
    title: "勇",
    content: "勇",
    pronunciation: "yǒnɡ",
    meaning: "敢干，有胆量",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1205",
    type: "character",
    title: "触",
    content: "触",
    pronunciation: "chù",
    meaning: "抵，用角顶撞有角者",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1206",
    type: "character",
    title: "课",
    content: "课",
    pronunciation: "kè",
    meaning: "学校里教学的科目、进程政治",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1207",
    type: "character",
    title: "敬",
    content: "敬",
    pronunciation: "jìnɡ",
    meaning: "尊重，热爱，仰慕，佩服尊",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1208",
    type: "character",
    title: "哭",
    content: "哭",
    pronunciation: "kū",
    meaning: "同本义(有声有泪)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1209",
    type: "character",
    title: "懂",
    content: "懂",
    pronunciation: "dǒnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1210",
    type: "character",
    title: "墙",
    content: "墙",
    pronunciation: "qiánɡ",
    meaning: "难除);土墙;围墙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1211",
    type: "character",
    title: "袭",
    content: "袭",
    pronunciation: "xí",
    meaning: "乘人不备而攻击",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1212",
    type: "character",
    title: "召",
    content: "召",
    pronunciation: "zhào",
    meaning: "又如召呼(呼唤;通知;交代);召致(使之至;唤来)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1213",
    type: "character",
    title: "罚",
    content: "罚",
    pronunciation: "fá",
    meaning: "又如罚规(处罚的规章);罚约(输者受罚的约定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1214",
    type: "character",
    title: "侠",
    content: "侠",
    pronunciation: "xiá",
    meaning: "同本义。指见义勇为、肯舍己助人的性格、气质或行为",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1215",
    type: "character",
    title: "厅",
    content: "厅",
    pronunciation: "tīnɡ",
    meaning: "聚会或宴会等用的大房间客",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1216",
    type: "character",
    title: "拜",
    content: "拜",
    pronunciation: "bài",
    meaning: "后世指下跪叩头。两腿跪地,两手扶地,低",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1217",
    type: "character",
    title: "巧",
    content: "巧",
    pronunciation: "qiǎo",
    meaning: "技术、手艺好，技艺精技",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1218",
    type: "character",
    title: "侧",
    content: "侧",
    pronunciation: "cè",
    meaning: "［侧声］即\"仄声\"，见 \"仄",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1219",
    type: "character",
    title: "韩",
    content: "韩",
    pronunciation: "hán",
    meaning: "井上的木栏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1220",
    type: "character",
    title: "冒",
    content: "冒",
    pronunciation: "mào",
    meaning: "上升，外透",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1221",
    type: "character",
    title: "债",
    content: "债",
    pronunciation: "zhai",
    meaning: "喻指应兑现的事情或所造成的损失",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1222",
    type: "character",
    title: "曼",
    content: "曼",
    pronunciation: "màn",
    meaning: "又如曼胡(无刃的长戟。一作镘胡);曼寿(长寿);曼啸(长啸)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1223",
    type: "character",
    title: "融",
    content: "融",
    pronunciation: "rónɡ",
    meaning: "受热溶化，消溶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1224",
    type: "character",
    title: "惯",
    content: "惯",
    pronunciation: "ɡuàn",
    meaning: "习以为常的，积久成性的习",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1225",
    type: "character",
    title: "享",
    content: "享",
    pronunciation: "xiǎnɡ",
    meaning: "受用，满足",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1226",
    type: "character",
    title: "戴",
    content: "戴",
    pronunciation: "dài",
    meaning: "古国名。故址在今河南省民权县东",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1227",
    type: "character",
    title: "童",
    content: "童",
    pronunciation: "tónɡ",
    meaning: "小孩子儿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1228",
    type: "character",
    title: "犹",
    content: "犹",
    pronunciation: "yóu",
    meaning: "一种猿类动物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1229",
    type: "character",
    title: "乘",
    content: "乘",
    pronunciation: "chénɡ",
    meaning: "骑，坐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1230",
    type: "character",
    title: "挂",
    content: "挂",
    pronunciation: "ɡuà",
    meaning: "悬，悬吊",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1231",
    type: "character",
    title: "奖",
    content: "奖",
    pronunciation: "jiǎnɡ",
    meaning: "劝勉，勉励当",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1232",
    type: "character",
    title: "绍",
    content: "绍",
    pronunciation: "shào",
    meaning: "继续，接续",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1233",
    type: "character",
    title: "厚",
    content: "厚",
    pronunciation: "hòu",
    meaning: "扁平物体，上下两个面的距离大，跟\"薄\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1234",
    type: "character",
    title: "纵",
    content: "纵",
    pronunciation: "zònɡ",
    meaning: "发，放",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1235",
    type: "character",
    title: "障",
    content: "障",
    pronunciation: "zhànɡ",
    meaning: "阻隔，阻碍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1236",
    type: "character",
    title: "讯",
    content: "讯",
    pronunciation: "xùn",
    meaning: "问，询问，特指审问",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1237",
    type: "character",
    title: "涉",
    content: "涉",
    pronunciation: "shè",
    meaning: "步行渡水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1238",
    type: "character",
    title: "彻",
    content: "彻",
    pronunciation: "chè",
    meaning: "通，透，深透",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1239",
    type: "character",
    title: "刊",
    content: "刊",
    pronunciation: "kān",
    meaning: "原指刻，雕刻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1240",
    type: "character",
    title: "丈",
    content: "丈",
    pronunciation: "zhànɡ",
    meaning: "市制长度单位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1241",
    type: "character",
    title: "爆",
    content: "爆",
    pronunciation: "bào",
    meaning: "又如车胎爆了;爆烈(猛烈爆炸);爆响(突然而猛裂地发出声响)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1242",
    type: "character",
    title: "乌",
    content: "乌",
    pronunciation: "wū",
    meaning: "古代神话传说太阳中有三足乌,因以乌为太阳的代称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1243",
    type: "character",
    title: "役",
    content: "役",
    pronunciation: "yì",
    meaning: "战事战",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1244",
    type: "character",
    title: "描",
    content: "描",
    pronunciation: "miáo",
    meaning: "依照原样画写或重复地画",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1245",
    type: "character",
    title: "洗",
    content: "洗",
    pronunciation: "xǐ",
    meaning: "用水或药品等去掉污垢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1246",
    type: "character",
    title: "玛",
    content: "玛",
    pronunciation: "mǎ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1247",
    type: "character",
    title: "患",
    content: "患",
    pronunciation: "huàn",
    meaning: "灾难，祸害水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1248",
    type: "character",
    title: "妙",
    content: "妙",
    pronunciation: "miào",
    meaning: "美，好",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1249",
    type: "character",
    title: "镜",
    content: "镜",
    pronunciation: "jìnɡ",
    meaning: "镜子，反映形象的器具",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1250",
    type: "character",
    title: "唱",
    content: "唱",
    pronunciation: "chànɡ",
    meaning: "吟咏，依照音律发声",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1251",
    type: "character",
    title: "烦",
    content: "烦",
    pronunciation: "fán",
    meaning: "急躁，苦闷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1252",
    type: "character",
    title: "签",
    content: "签",
    pronunciation: "qiān",
    meaning: "亲笔署名或画上符号",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1253",
    type: "character",
    title: "仙",
    content: "仙",
    pronunciation: "xiān",
    meaning: "仙人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1254",
    type: "character",
    title: "彼",
    content: "彼",
    pronunciation: "bǐ",
    meaning: "那,与此相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1255",
    type: "character",
    title: "弗",
    content: "弗",
    pronunciation: "fú",
    meaning: "违拗;拂逆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1256",
    type: "character",
    title: "症",
    content: "症",
    pronunciation: "zhènɡ",
    meaning: "腹中结块的病",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1257",
    type: "character",
    title: "仿",
    content: "仿",
    pronunciation: "fǎnɡ",
    meaning: "效法，照样做",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1258",
    type: "character",
    title: "倾",
    content: "倾",
    pronunciation: "qīnɡ",
    meaning: "侧，斜，歪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1259",
    type: "character",
    title: "牌",
    content: "牌",
    pronunciation: "pái",
    meaning: "用作标志、凭信物等的板招",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1260",
    type: "character",
    title: "陷",
    content: "陷",
    pronunciation: "xiàn",
    meaning: "掉进，坠入，沉下",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1262",
    type: "character",
    title: "轰",
    content: "轰",
    pronunciation: "hōnɡ",
    meaning: "揺）hōng",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1263",
    type: "character",
    title: "咱",
    content: "咱",
    pronunciation: "zán",
    meaning: "又如咱可(咱们;我们);咱家(我);咱每(咱们。指我)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1264",
    type: "character",
    title: "菜",
    content: "菜",
    pronunciation: "cài",
    meaning: "又如种菜;干菜(晒干的蔬菜);菜食(以食菜为主)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1265",
    type: "character",
    title: "闭",
    content: "闭",
    pronunciation: "bì",
    meaning: "又如闭扫(即闭门欲扫。指闭门谢客);闭影(关门不与外界往来)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1266",
    type: "character",
    title: "奋",
    content: "奋",
    pronunciation: "fèn",
    meaning: "鸟类展翅",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1267",
    type: "character",
    title: "庆",
    content: "庆",
    pronunciation: "qìnɡ",
    meaning: ",表心意;下边是攵,表示往。意思跟甲骨文相同。本义棕;庆贺)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1268",
    type: "character",
    title: "撤",
    content: "撤",
    pronunciation: "chè",
    meaning: "取销，免除，除去",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1269",
    type: "character",
    title: "泪",
    content: "泪",
    pronunciation: "lèi",
    meaning: "眼泪，泪腺分泌出的液体热",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1270",
    type: "character",
    title: "茶",
    content: "茶",
    pronunciation: "chá",
    meaning: "又如茶市(茶叶市场)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1271",
    type: "character",
    title: "疾",
    content: "疾",
    pronunciation: "jí",
    meaning: "轻微的叫疾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1272",
    type: "character",
    title: "缘",
    content: "缘",
    pronunciation: "yuán",
    meaning: "边边",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1273",
    type: "character",
    title: "播",
    content: "播",
    pronunciation: "bō",
    meaning: "又如条播;夏播;播田(种田;种植);播植(播种;种植);播谷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1274",
    type: "character",
    title: "朗",
    content: "朗",
    pronunciation: "lǎnɡ",
    meaning: "明亮明",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1275",
    type: "character",
    title: "杜",
    content: "杜",
    pronunciation: "dù",
    meaning: "又如杜耳恶闻(塞住耳朵不愿听);杜隔(阻塞隔离);杜闭(堵塞",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1276",
    type: "character",
    title: "奶",
    content: "奶",
    pronunciation: "nǎi",
    meaning: "乳房",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1277",
    type: "character",
    title: "季",
    content: "季",
    pronunciation: "jì",
    meaning: "兄弟排行，有时用伯、仲、叔、",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1278",
    type: "character",
    title: "丹",
    content: "丹",
    pronunciation: "dān",
    meaning: "道家炼制的所谓长生不老药。又称丹头;丹液",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1279",
    type: "character",
    title: "狗",
    content: "狗",
    pronunciation: "ɡǒu",
    meaning: "家畜之一，又叫\"犬\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1280",
    type: "character",
    title: "尾",
    content: "尾",
    pronunciation: "wěi",
    meaning: "尾巴，脊椎动物躯干背面最后的一段，泛指低等动物身体末端的突出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1281",
    type: "character",
    title: "仪",
    content: "仪",
    pronunciation: "yí",
    meaning: "容貌，举止",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1282",
    type: "character",
    title: "偷",
    content: "偷",
    pronunciation: "tōu",
    meaning: "窃取，暗中拿取，也指窃取东西的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1283",
    type: "character",
    title: "奔",
    content: "奔",
    pronunciation: "bēn",
    meaning: "逃跑,逃亡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1284",
    type: "character",
    title: "珠",
    content: "珠",
    pronunciation: "zhū",
    meaning: "所货西洋珠。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1285",
    type: "character",
    title: "虫",
    content: "虫",
    pronunciation: "chónɡ",
    meaning: "又如虫豸(昆虫;虫子);虫蛭(小虫子);虫天(百虫能各自适应",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1286",
    type: "character",
    title: "驻",
    content: "驻",
    pronunciation: "zhù",
    meaning: "又如驻马(驻鞍、驻勒。都指使马停下不走)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1287",
    type: "character",
    title: "孔",
    content: "孔",
    pronunciation: "kǒnɡ",
    meaning: "小洞，窟窿针",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1288",
    type: "character",
    title: "宜",
    content: "宜",
    pronunciation: "yí",
    meaning: "适当，合适适",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1289",
    type: "character",
    title: "艾",
    content: "艾",
    pronunciation: "ài",
    meaning: "多年生草本，有香气，秋季开黄色小花",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1290",
    type: "character",
    title: "桥",
    content: "桥",
    pronunciation: "qiáo",
    meaning: "又如桥阁(傍山架木为路。即栈道,阁道);桥津(桥头。津,水边",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1291",
    type: "character",
    title: "淡",
    content: "淡",
    pronunciation: "dàn",
    meaning: "又如淡酒;淡味;淡句(平淡乏味的诗句);淡而不厌(指诗文恬淡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1292",
    type: "character",
    title: "翼",
    content: "翼",
    pronunciation: "yì",
    meaning: "翅膀举首奋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1293",
    type: "character",
    title: "恨",
    content: "恨",
    pronunciation: "hèn",
    meaning: "遗憾，不满意",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1294",
    type: "character",
    title: "繁",
    content: "繁",
    pronunciation: "fán",
    meaning: "多，重，盛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1295",
    type: "character",
    title: "寒",
    content: "寒",
    pronunciation: "hán",
    meaning: "冷，凉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1296",
    type: "character",
    title: "伴",
    content: "伴",
    pronunciation: "bàn",
    meaning: "陪同;依随",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1297",
    type: "character",
    title: "叹",
    content: "叹",
    pronunciation: "tàn",
    meaning: "吟咏一倡三",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1298",
    type: "character",
    title: "旦",
    content: "旦",
    pronunciation: "dàn",
    meaning: "又如旦日(天亮时);旦明(天亮时)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1299",
    type: "character",
    title: "愈",
    content: "愈",
    pronunciation: "yù",
    meaning: "瘉、",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1300",
    type: "character",
    title: "潮",
    content: "潮",
    pronunciation: "cháo",
    meaning: "海水定时涨落的现象早",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1301",
    type: "character",
    title: "粮",
    content: "粮",
    pronunciation: "liánɡ",
    meaning: "可吃的谷类、豆类等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1302",
    type: "character",
    title: "缩",
    content: "缩",
    pronunciation: "suō",
    meaning: "用绳子捆起来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1303",
    type: "character",
    title: "罢",
    content: "罢",
    pronunciation: "bà",
    meaning: "又如罢谢(辞官去职);罢归(辞职或免官归里)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1304",
    type: "character",
    title: "聚",
    content: "聚",
    pronunciation: "jù",
    meaning: "集合，会合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1305",
    type: "character",
    title: "径",
    content: "径",
    pronunciation: "jìnɡ",
    meaning: "小路山",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1306",
    type: "character",
    title: "恰",
    content: "恰",
    pronunciation: "qià",
    meaning: "又如恰恰(用心的样子)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1307",
    type: "character",
    title: "挑",
    content: "挑",
    pronunciation: "tiāo",
    meaning: "用肩担着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1308",
    type: "character",
    title: "袋",
    content: "袋",
    pronunciation: "dài",
    meaning: "又如网袋;塑料袋;旅行袋;工具袋;子弹袋;烟叶袋;水泥袋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1309",
    type: "character",
    title: "灰",
    content: "灰",
    pronunciation: "huī",
    meaning: "物质燃烧后剩下的粉末草",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1310",
    type: "character",
    title: "捕",
    content: "捕",
    pronunciation: "bǔ",
    meaning: "【捕风捉影】比喻说话或做事不凭事实根据，而是用似是而非的迹象",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1311",
    type: "character",
    title: "徐",
    content: "徐",
    pronunciation: "xú",
    meaning: "栎树，也叫\"柞树\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1312",
    type: "character",
    title: "珍",
    content: "珍",
    pronunciation: "zhēn",
    meaning: "宝贝，宝物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1313",
    type: "character",
    title: "幕",
    content: "幕",
    pronunciation: "mù",
    meaning: "帐篷帐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1314",
    type: "character",
    title: "映",
    content: "映",
    pronunciation: "yìnɡ",
    meaning: "受光线照射而显出天水相",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1315",
    type: "character",
    title: "裂",
    content: "裂",
    pronunciation: "liè",
    meaning: "破开，开了缝破",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1316",
    type: "character",
    title: "泰",
    content: "泰",
    pronunciation: "tài",
    meaning: "平安，安定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1317",
    type: "character",
    title: "隔",
    content: "隔",
    pronunciation: "ɡé",
    meaning: "拦断，互不接触，分开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1318",
    type: "character",
    title: "启",
    content: "启",
    pronunciation: "qǐ",
    meaning: "开，打开，开发，开拓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1319",
    type: "character",
    title: "尖",
    content: "尖",
    pronunciation: "jiān",
    meaning: "物体末端锐利或细小，也指物体细锐的末端塔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1320",
    type: "character",
    title: "忠",
    content: "忠",
    pronunciation: "zhōnɡ",
    meaning: "志虑忠纯。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1321",
    type: "character",
    title: "累",
    content: "累",
    pronunciation: "lèi",
    meaning: "疲劳劳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1322",
    type: "character",
    title: "炎",
    content: "炎",
    pronunciation: "yán",
    meaning: "又如炎上(火焰向上;火向上燃烧)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1323",
    type: "character",
    title: "暂",
    content: "暂",
    pronunciation: "zàn",
    meaning: "求假暂归。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1324",
    type: "character",
    title: "估",
    content: "估",
    pronunciation: "ɡū",
    meaning: "通贾。商人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1325",
    type: "character",
    title: "泛",
    content: "泛",
    pronunciation: "fàn",
    meaning: "漂浮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1326",
    type: "character",
    title: "荒",
    content: "荒",
    pronunciation: "huānɡ",
    meaning: "庄稼收成不好",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1327",
    type: "character",
    title: "偿",
    content: "偿",
    pronunciation: "chánɡ",
    meaning: "归还，赔给",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1328",
    type: "character",
    title: "横",
    content: "横",
    pronunciation: "hénɡ",
    meaning: "粗暴，凶狠，残暴蛮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1329",
    type: "character",
    title: "拒",
    content: "拒",
    pronunciation: "jù",
    meaning: "抵御，抵抗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1330",
    type: "character",
    title: "瑞",
    content: "瑞",
    pronunciation: "ruì",
    meaning: "迷信者所谓的\"吉凶预兆\"自己认为是嘉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1331",
    type: "character",
    title: "忆",
    content: "忆",
    pronunciation: "yì",
    meaning: "思念，回想",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1332",
    type: "character",
    title: "孤",
    content: "孤",
    pronunciation: "ɡū",
    meaning: "幼年丧父或父母双亡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1333",
    type: "character",
    title: "鼻",
    content: "鼻",
    pronunciation: "bí",
    meaning: "同本义◆吸兼嗅觉的器官",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1334",
    type: "character",
    title: "闹",
    content: "闹",
    pronunciation: "nào",
    meaning: "人多声音杂乱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1335",
    type: "character",
    title: "羊",
    content: "羊",
    pronunciation: "yánɡ",
    meaning: "哺乳动物，反刍类",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1336",
    type: "character",
    title: "呆",
    content: "呆",
    pronunciation: "dāi",
    meaning: "傻老公);呆物(詈词。傻家伙);呆性(傻气;痴迷劲儿)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1337",
    type: "character",
    title: "厉",
    content: "厉",
    pronunciation: "lì",
    meaning: "\"砺\"的本字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1338",
    type: "character",
    title: "衡",
    content: "衡",
    pronunciation: "hénɡ",
    meaning: "称东西轻重的器具，如秤，天平等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1339",
    type: "character",
    title: "胞",
    content: "胞",
    pronunciation: "bāo",
    meaning: "又如胞衣地(埋胞衣的地方);胞胎(犹胞衣。常指娘胎)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1340",
    type: "character",
    title: "零",
    content: "零",
    pronunciation: "línɡ",
    meaning: "落，衰落，雕落",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1341",
    type: "character",
    title: "穷",
    content: "穷",
    pronunciation: "qiónɡ",
    meaning: "不得志，不显贵，跟\"达\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1342",
    type: "character",
    title: "舍",
    content: "舍",
    pronunciation: "shě",
    meaning: "放弃，不要",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1343",
    type: "character",
    title: "码",
    content: "码",
    pronunciation: "mǎ",
    meaning: "代表数目的符号数",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1344",
    type: "character",
    title: "赫",
    content: "赫",
    pronunciation: "hè",
    meaning: "火红色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1345",
    type: "character",
    title: "婆",
    content: "婆",
    pronunciation: "pó",
    meaning: "年老的妇女老太",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1346",
    type: "character",
    title: "魂",
    content: "魂",
    pronunciation: "hún",
    meaning: "又如魂识(心灵;魂灵);魂气(灵魂);魂骸(死者的灵魂和躯体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1347",
    type: "character",
    title: "灾",
    content: "灾",
    pronunciation: "zāi",
    meaning: "水、火、荒、旱、虫等所造成的祸害",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1348",
    type: "character",
    title: "洪",
    content: "洪",
    pronunciation: "hónɡ",
    meaning: "又如山洪;防洪;蓄洪;分洪;洪河(大河);洪峰",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1349",
    type: "character",
    title: "腿",
    content: "腿",
    pronunciation: "tuǐ",
    meaning: "胫部，股部，下肢小",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1350",
    type: "character",
    title: "胆",
    content: "胆",
    pronunciation: "dǎn",
    meaning: "同本义。通称胆或苦胆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1351",
    type: "character",
    title: "津",
    content: "津",
    pronunciation: "jīn",
    meaning: "渡口",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1352",
    type: "character",
    title: "俗",
    content: "俗",
    pronunciation: "sú",
    meaning: "风俗土",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1353",
    type: "character",
    title: "辩",
    content: "辩",
    pronunciation: "biàn",
    meaning: "又如辩证;辩日(古代传说辩论太阳离地球远近的故事)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1354",
    type: "character",
    title: "胸",
    content: "胸",
    pronunciation: "xiōnɡ",
    meaning: "人和动物躯干的一部分，在头颈和腹部之间",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1355",
    type: "character",
    title: "晓",
    content: "晓",
    pronunciation: "xiǎo",
    meaning: "天亮拂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1356",
    type: "character",
    title: "劲",
    content: "劲",
    pronunciation: "jìn",
    meaning: "正直，挺拔，坚强有力",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1357",
    type: "character",
    title: "贫",
    content: "贫",
    pronunciation: "pín",
    meaning: "穷，跟\"富\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1358",
    type: "character",
    title: "仁",
    content: "仁",
    pronunciation: "rén",
    meaning: "果核或种子里最内的部分，也指某些硬壳中可吃的部分杏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1359",
    type: "character",
    title: "偶",
    content: "偶",
    pronunciation: "ǒu",
    meaning: "木头或泥土等制成的人像木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1360",
    type: "character",
    title: "辑",
    content: "辑",
    pronunciation: "jí",
    meaning: "〈古〉车厢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1361",
    type: "character",
    title: "邦",
    content: "邦",
    pronunciation: "bānɡ",
    meaning: "②国友好邻～。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1362",
    type: "character",
    title: "恢",
    content: "恢",
    pronunciation: "huī",
    meaning: "广大，宽广",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1363",
    type: "character",
    title: "赖",
    content: "赖",
    pronunciation: "lài",
    meaning: "倚靠，仗持依",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1364",
    type: "character",
    title: "圈",
    content: "圈",
    pronunciation: "quān",
    meaning: "环形，环形的东西圆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1365",
    type: "character",
    title: "摸",
    content: "摸",
    pronunciation: "mō",
    meaning: "用手触及或抚摩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1366",
    type: "character",
    title: "仰",
    content: "仰",
    pronunciation: "yǎnɡ",
    meaning: "抬头，脸向上，跟\"俯\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1367",
    type: "character",
    title: "润",
    content: "润",
    pronunciation: "rùn",
    meaning: "潮湿，不干枯湿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1368",
    type: "character",
    title: "堆",
    content: "堆",
    pronunciation: "duī",
    meaning: "土墩,沙墩或水中聚集的礁石",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1369",
    type: "character",
    title: "碰",
    content: "碰",
    pronunciation: "pènɡ",
    meaning: "撞，触",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1370",
    type: "character",
    title: "艇",
    content: "艇",
    pronunciation: "tǐnɡ",
    meaning: "轻便或轻便快速的船游",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1371",
    type: "character",
    title: "稍",
    content: "稍",
    pronunciation: "shāo",
    meaning: "又如稍秣(给牛马吃的草料)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1372",
    type: "character",
    title: "迟",
    content: "迟",
    pronunciation: "chí",
    meaning: "缓慢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1373",
    type: "character",
    title: "辆",
    content: "辆",
    pronunciation: "liànɡ",
    meaning: "用于车,指单个数",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1374",
    type: "character",
    title: "废",
    content: "废",
    pronunciation: "fèi",
    meaning: "停止，放弃",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1375",
    type: "character",
    title: "净",
    content: "净",
    pronunciation: "jìnɡ",
    meaning: "清洁干",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1376",
    type: "character",
    title: "凶",
    content: "凶",
    pronunciation: "xiōnɡ",
    meaning: "不吉祥，不幸的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1377",
    type: "character",
    title: "署",
    content: "署",
    pronunciation: "shǔ",
    meaning: "布置，安排部",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1378",
    type: "character",
    title: "壁",
    content: "壁",
    pronunciation: "bì",
    meaning: "①墙～报。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1379",
    type: "character",
    title: "御",
    content: "御",
    pronunciation: "yù",
    meaning: "驾驭车马",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1380",
    type: "character",
    title: "奉",
    content: "奉",
    pronunciation: "fènɡ",
    meaning: "两手捧着臣愿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1381",
    type: "character",
    title: "旋",
    content: "旋",
    pronunciation: "xuán",
    meaning: "转动，弯转",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1382",
    type: "character",
    title: "冬",
    content: "冬",
    pronunciation: "dōnɡ",
    meaning: "一年四季中秋春之间的季节,天文学上认为是从12月至3月,农历",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1383",
    type: "character",
    title: "矿",
    content: "矿",
    pronunciation: "kuànɡ",
    meaning: "蕴藏在地层中可供开采使用的自然资源铁",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1384",
    type: "character",
    title: "抬",
    content: "抬",
    pronunciation: "tái",
    meaning: "举，提高，使上升",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1385",
    type: "character",
    title: "蛋",
    content: "蛋",
    pronunciation: "dàn",
    meaning: "禽类或龟、蛇等所产的卵",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1386",
    type: "character",
    title: "晨",
    content: "晨",
    pronunciation: "chén",
    meaning: "【晨昏】早晨和晚上。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1387",
    type: "character",
    title: "伏",
    content: "伏",
    pronunciation: "fú",
    meaning: "趴，脸面向下，身体前屈",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1388",
    type: "character",
    title: "吹",
    content: "吹",
    pronunciation: "chuī",
    meaning: "撮起嘴唇用力出气",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1389",
    type: "character",
    title: "鸡",
    content: "鸡",
    pronunciation: "jī",
    meaning: "又如鸡男(雄鸡);鸡坊(养鸡场);鸡肤(鸡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1390",
    type: "character",
    title: "倍",
    content: "倍",
    pronunciation: "bèi",
    meaning: "背弃;背叛◇作背",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1391",
    type: "character",
    title: "糊",
    content: "糊",
    pronunciation: "hú",
    meaning: "粘合用的稠汁浆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1392",
    type: "character",
    title: "秦",
    content: "秦",
    pronunciation: "qín",
    meaning: "周代诸侯国名，战国时七雄之一，在今陕西和甘肃一带",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1393",
    type: "character",
    title: "盾",
    content: "盾",
    pronunciation: "dùn",
    meaning: "比喻推托的借口",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1394",
    type: "character",
    title: "杯",
    content: "杯",
    pronunciation: "bēi",
    meaning: "同本义,也称耳杯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1395",
    type: "character",
    title: "租",
    content: "租",
    pronunciation: "zū",
    meaning: "付出代价借用房屋、器物等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1396",
    type: "character",
    title: "骑",
    content: "骑",
    pronunciation: "qí",
    meaning: "两腿跨坐在牲畜或其它东西上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1397",
    type: "character",
    title: "乏",
    content: "乏",
    pronunciation: "fá",
    meaning: "缺少缺",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1398",
    type: "character",
    title: "隆",
    content: "隆",
    pronunciation: "lónɡ",
    meaning: "丰大;高",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1399",
    type: "character",
    title: "诊",
    content: "诊",
    pronunciation: "zhěn",
    meaning: "医生为断定疾症而察看病人身体内部、外部的情况门～。～断。～室",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1400",
    type: "character",
    title: "奴",
    content: "奴",
    pronunciation: "nú",
    meaning: "阶级社会中，丧失自由，遭受压迫、剥削、役使的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1401",
    type: "character",
    title: "摄",
    content: "摄",
    pronunciation: "shè",
    meaning: "拿，取，吸取",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1402",
    type: "character",
    title: "丧",
    content: "丧",
    pronunciation: "sànɡ",
    meaning: "失掉，死亡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1403",
    type: "character",
    title: "污",
    content: "污",
    pronunciation: "wū",
    meaning: "停积不流的水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1404",
    type: "character",
    title: "渡",
    content: "渡",
    pronunciation: "dù",
    meaning: "又如渡仔(渡子。摆渡的人);渡杯(比喻高僧的行踪);渡客(乘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1405",
    type: "character",
    title: "旗",
    content: "旗",
    pronunciation: "qí",
    meaning: "用布、绸、纸等做成的标帜，多为长方形或方形",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1406",
    type: "character",
    title: "甘",
    content: "甘",
    pronunciation: "ɡān",
    meaning: "甜，跟\"苦\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1407",
    type: "character",
    title: "耐",
    content: "耐",
    pronunciation: "nai",
    meaning: "禁得起，受得住",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1408",
    type: "character",
    title: "凭",
    content: "凭",
    pronunciation: "pínɡ",
    meaning: "靠着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1409",
    type: "character",
    title: "扎",
    content: "扎",
    pronunciation: "zhā",
    meaning: "缠束，捆，把",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1410",
    type: "character",
    title: "抢",
    content: "抢",
    pronunciation: "qiǎnɡ",
    meaning: "夺，硬拿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1411",
    type: "character",
    title: "绪",
    content: "绪",
    pronunciation: "xù",
    meaning: "丝头",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1412",
    type: "character",
    title: "粗",
    content: "粗",
    pronunciation: "cū",
    meaning: "又如粗糠(糠。稻、麦,谷子等农作物子实的皮或壳)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1413",
    type: "character",
    title: "肩",
    content: "肩",
    pronunciation: "jiān",
    meaning: "肩膀，颈项旁边胳膊上边的部分比",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1414",
    type: "character",
    title: "梁",
    content: "梁",
    pronunciation: "liánɡ",
    meaning: "樑）liáng",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1415",
    type: "character",
    title: "幻",
    content: "幻",
    pronunciation: "huàn",
    meaning: "空虚的，不真实的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1416",
    type: "character",
    title: "菲",
    content: "菲",
    pronunciation: "fēi",
    meaning: "微，薄",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1417",
    type: "character",
    title: "皆",
    content: "皆",
    pronunciation: "jiē",
    meaning: "百堵皆兴。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1418",
    type: "character",
    title: "碎",
    content: "碎",
    pronunciation: "suì",
    meaning: "完整的东西破裂成小块、细片破",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1419",
    type: "character",
    title: "宙",
    content: "宙",
    pronunciation: "zhòu",
    meaning: "古往今来的时间;时间的总称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1420",
    type: "character",
    title: "叔",
    content: "叔",
    pronunciation: "shū",
    meaning: "兄弟排行伯是老大，",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1421",
    type: "character",
    title: "岩",
    content: "岩",
    pronunciation: "yán",
    meaning: "高峻的山崖千",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1422",
    type: "character",
    title: "荡",
    content: "荡",
    pronunciation: "dànɡ",
    meaning: "动;摇动;震动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1423",
    type: "character",
    title: "综",
    content: "综",
    pronunciation: "zōnɡ",
    meaning: "聚总，集合，组合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1424",
    type: "character",
    title: "爬",
    content: "爬",
    pronunciation: "pá",
    meaning: "上下肢伏地行走，虫类、爬行动物等的行走",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1425",
    type: "character",
    title: "荷",
    content: "荷",
    pronunciation: "hé",
    meaning: "植物名。即莲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1426",
    type: "character",
    title: "悉",
    content: "悉",
    pronunciation: "xī",
    meaning: "知道熟",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1427",
    type: "character",
    title: "蒂",
    content: "蒂",
    pronunciation: "dì",
    meaning: "引申为末尾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1428",
    type: "character",
    title: "返",
    content: "返",
    pronunciation: "fǎn",
    meaning: "归，回",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1429",
    type: "character",
    title: "井",
    content: "井",
    pronunciation: "jǐnɡ",
    meaning: "凿地挖成能取出水的深洞水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1430",
    type: "character",
    title: "壮",
    content: "壮",
    pronunciation: "zhuànɡ",
    meaning: "强健，有力强",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1431",
    type: "character",
    title: "薄",
    content: "薄",
    pronunciation: "báo",
    meaning: "土地含养分少,不肥沃的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1432",
    type: "character",
    title: "悄",
    content: "悄",
    pronunciation: "qiāo",
    meaning: "忧愁",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1433",
    type: "character",
    title: "扫",
    content: "扫",
    pronunciation: "sǎo",
    meaning: "用扫帚等除去尘土、垃圾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1434",
    type: "character",
    title: "敏",
    content: "敏",
    pronunciation: "mǐn",
    meaning: "聪明，机智，迅速，反应快",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1435",
    type: "character",
    title: "碍",
    content: "碍",
    pronunciation: "ài",
    meaning: "同本义。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1436",
    type: "character",
    title: "殖",
    content: "殖",
    pronunciation: "zhí",
    meaning: "生长,繁殖",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1437",
    type: "character",
    title: "详",
    content: "详",
    pronunciation: "xiánɡ",
    meaning: "细密，完备",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1438",
    type: "character",
    title: "迪",
    content: "迪",
    pronunciation: "dí",
    meaning: "行,出走",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1439",
    type: "character",
    title: "矛",
    content: "矛",
    pronunciation: "máo",
    meaning: "〈古〉兵器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1440",
    type: "character",
    title: "霍",
    content: "霍",
    pronunciation: "huò",
    meaning: "鸟疾飞的声音",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1441",
    type: "character",
    title: "允",
    content: "允",
    pronunciation: "yǔn",
    meaning: "认可，答应",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1442",
    type: "character",
    title: "幅",
    content: "幅",
    pronunciation: "fú",
    meaning: "幅面，布、绸、呢绒等的宽度单",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1443",
    type: "character",
    title: "撒",
    content: "撒",
    pronunciation: "sā",
    meaning: "放，放开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1444",
    type: "character",
    title: "剩",
    content: "剩",
    pronunciation: "shènɡ",
    meaning: "又如剩员(多余的人员);剩语(多余的话);剩货",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1445",
    type: "character",
    title: "凯",
    content: "凯",
    pronunciation: "kǎi",
    meaning: "军队打胜仗后所奏的乐曲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1446",
    type: "character",
    title: "颗",
    content: "颗",
    pronunciation: "kē",
    meaning: "又如颗盐(俗称粒盐。一种粗盐);颗子(方言。指小米)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1447",
    type: "character",
    title: "骂",
    content: "骂",
    pronunciation: "mà",
    meaning: "用粗野的话侮辱人辱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1448",
    type: "character",
    title: "赏",
    content: "赏",
    pronunciation: "shǎnɡ",
    meaning: "赐，奖，给予",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1449",
    type: "character",
    title: "液",
    content: "液",
    pronunciation: "yè",
    meaning: "又如泪液(眼内泪腺分泌的无色透明液体);胃液;津液;唾液;溶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1450",
    type: "character",
    title: "番",
    content: "番",
    pronunciation: "fān",
    meaning: "更替,轮值",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1451",
    type: "character",
    title: "箱",
    content: "箱",
    pronunciation: "xiānɡ",
    meaning: "收藏衣物等的用具",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1452",
    type: "character",
    title: "贴",
    content: "贴",
    pronunciation: "tiē",
    meaning: "粘附粘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1453",
    type: "character",
    title: "漫",
    content: "漫",
    pronunciation: "màn",
    meaning: "淹，水涨，水满外溢水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1454",
    type: "character",
    title: "酸",
    content: "酸",
    pronunciation: "suān",
    meaning: "像醋的味道或气味",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1455",
    type: "character",
    title: "郎",
    content: "郎",
    pronunciation: "lánɡ",
    meaning: "称呼青少年男子英俊",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1456",
    type: "character",
    title: "腰",
    content: "腰",
    pronunciation: "yāo",
    meaning: "身体的中部，胁下胯上的部分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1457",
    type: "character",
    title: "舒",
    content: "舒",
    pronunciation: "shū",
    meaning: "展开，宽解，身心愉快",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1458",
    type: "character",
    title: "眉",
    content: "眉",
    pronunciation: "méi",
    meaning: "额下眼上横排呈弯形的一小撮毛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1459",
    type: "character",
    title: "忧",
    content: "忧",
    pronunciation: "yōu",
    meaning: "发愁，担心",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1460",
    type: "character",
    title: "浮",
    content: "浮",
    pronunciation: "fú",
    meaning: "漂，跟\"沉\"相对漂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1461",
    type: "character",
    title: "辛",
    content: "辛",
    pronunciation: "xīn",
    meaning: "葱蒜等带刺激性的蔬菜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1462",
    type: "character",
    title: "恋",
    content: "恋",
    pronunciation: "liàn",
    meaning: "思念不忘，不忍分离留",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1463",
    type: "character",
    title: "餐",
    content: "餐",
    pronunciation: "cān",
    meaning: "又如进餐;会餐;野餐;就餐;聚餐;餐玉(吞食玉屑。古时认为服",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1464",
    type: "character",
    title: "吓",
    content: "吓",
    pronunciation: "xià",
    meaning: "威胁人，使人害怕恐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1465",
    type: "character",
    title: "挺",
    content: "挺",
    pronunciation: "tǐnɡ",
    meaning: "笔直笔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1466",
    type: "character",
    title: "励",
    content: "励",
    pronunciation: "lì",
    meaning: "又如励精(振作精神)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1467",
    type: "character",
    title: "辞",
    content: "辞",
    pronunciation: "cí",
    meaning: "①优美的语言；言词～藻、修～。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1468",
    type: "character",
    title: "艘",
    content: "艘",
    pronunciation: "sōu",
    meaning: "海中大船",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1469",
    type: "character",
    title: "键",
    content: "键",
    pronunciation: "jiàn",
    meaning: "车轴上的铁条，用以管住车轮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1470",
    type: "character",
    title: "伍",
    content: "伍",
    pronunciation: "wǔ",
    meaning: "\"五\"的大写",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1471",
    type: "character",
    title: "峰",
    content: "峰",
    pronunciation: "fēnɡ",
    meaning: "高而尖的山头山",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1472",
    type: "character",
    title: "尺",
    content: "尺",
    pronunciation: "chǐ",
    meaning: "旧时乐谱记音符号之一，相当于简谱的\"2\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1473",
    type: "character",
    title: "昨",
    content: "昨",
    pronunciation: "zuó",
    meaning: "泛指往日;过去",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1474",
    type: "character",
    title: "黎",
    content: "黎",
    pronunciation: "lí",
    meaning: "众，多",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1475",
    type: "character",
    title: "辈",
    content: "辈",
    pronunciation: "bèi",
    meaning: "也指车列,车队",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1476",
    type: "character",
    title: "贯",
    content: "贯",
    pronunciation: "ɡuàn",
    meaning: "〈古〉穿钱的绳索，即钱串",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1477",
    type: "character",
    title: "侦",
    content: "侦",
    pronunciation: "zhēn",
    meaning: "又如侦知(探知;暗中查明);侦伺(窥探,伺望);侦者(侦探敌",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1478",
    type: "character",
    title: "滑",
    content: "滑",
    pronunciation: "huá",
    meaning: "光溜，不粗涩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1479",
    type: "character",
    title: "券",
    content: "券",
    pronunciation: "quàn",
    meaning: "票证或凭据国库",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1480",
    type: "character",
    title: "崇",
    content: "崇",
    pronunciation: "chónɡ",
    meaning: "高;高大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1481",
    type: "character",
    title: "扰",
    content: "扰",
    pronunciation: "rǎo",
    meaning: "打搅，侵搅打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1482",
    type: "character",
    title: "宪",
    content: "宪",
    pronunciation: "xiàn",
    meaning: "法令",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1483",
    type: "character",
    title: "绕",
    content: "绕",
    pronunciation: "rào",
    meaning: "又如绕梁声(形容歌声优美动听,长久萦回耳畔);绕袭(迂回突袭",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1484",
    type: "character",
    title: "趋",
    content: "趋",
    pronunciation: "qū",
    meaning: "快走",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1485",
    type: "character",
    title: "慈",
    content: "慈",
    pronunciation: "cí",
    meaning: "父母威严而有慈,则子女畏慎而生孝矣。╠",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1486",
    type: "character",
    title: "乔",
    content: "乔",
    pronunciation: "qiáo",
    meaning: "高耸。多用以形容树木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1487",
    type: "character",
    title: "阅",
    content: "阅",
    pronunciation: "yuè",
    meaning: "引申为计算",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1488",
    type: "character",
    title: "汗",
    content: "汗",
    pronunciation: "hàn",
    meaning: "可汗,古代鲜卑、柔然、突厥、回纥、蒙古等族对其统治者的称号",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1489",
    type: "character",
    title: "枝",
    content: "枝",
    pronunciation: "zhī",
    meaning: "植物主干上分出来的茎条",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1490",
    type: "character",
    title: "拖",
    content: "拖",
    pronunciation: "tuō",
    meaning: "拉，拽，牵引",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1491",
    type: "character",
    title: "墨",
    content: "墨",
    pronunciation: "mò",
    meaning: "书画用的黑色颜料",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1492",
    type: "character",
    title: "胁",
    content: "胁",
    pronunciation: "xié",
    meaning: "胸部的两侧，从腋下到肋骨尽处的部分两",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1493",
    type: "character",
    title: "插",
    content: "插",
    pronunciation: "chā",
    meaning: "参与,加入",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1494",
    type: "character",
    title: "箭",
    content: "箭",
    pronunciation: "jiàn",
    meaning: "搭在弓弩上发射的竹制武器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1495",
    type: "character",
    title: "腊",
    content: "腊",
    pronunciation: "là",
    meaning: "〈古〉十二月的一种祭祀◇因称夏历十二月为\"腊月\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1496",
    type: "character",
    title: "粉",
    content: "粉",
    pronunciation: "fěn",
    meaning: "细末",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1497",
    type: "character",
    title: "泥",
    content: "泥",
    pronunciation: "ní",
    meaning: "土和水混合的东西烂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1498",
    type: "character",
    title: "氏",
    content: "氏",
    pronunciation: "shì",
    meaning: "〈古〉同姓贵族若干分支各有的称号叫\"氏\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1499",
    type: "character",
    title: "彭",
    content: "彭",
    pronunciation: "pénɡ",
    meaning: "在湖北省房县",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1500",
    type: "character",
    title: "拔",
    content: "拔",
    pronunciation: "bá",
    meaning: "又如拔毛;拔草;拔秧",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1501",
    type: "character",
    title: "骗",
    content: "骗",
    pronunciation: "piàn",
    meaning: "欺蒙，说假话欺",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1502",
    type: "character",
    title: "凤",
    content: "凤",
    pronunciation: "fènɡ",
    meaning: "古时比喻有圣德的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1503",
    type: "character",
    title: "慧",
    content: "慧",
    pronunciation: "huì",
    meaning: "注慧,儇,皆意精明。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1504",
    type: "character",
    title: "媒",
    content: "媒",
    pronunciation: "méi",
    meaning: "撮合男女婚事做",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1505",
    type: "character",
    title: "佩",
    content: "佩",
    pronunciation: "pèi",
    meaning: "〈古〉系在衣带上的装饰品，又特指此装饰品上的玉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1506",
    type: "character",
    title: "愤",
    content: "愤",
    pronunciation: "fèn",
    meaning: "因不满意而激动发怒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1507",
    type: "character",
    title: "扑",
    content: "扑",
    pronunciation: "pū",
    meaning: "拍，轻打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1508",
    type: "character",
    title: "龄",
    content: "龄",
    pronunciation: "línɡ",
    meaning: "岁数年",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1509",
    type: "character",
    title: "驱",
    content: "驱",
    pronunciation: "qū",
    meaning: "赶马",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1510",
    type: "character",
    title: "惜",
    content: "惜",
    pronunciation: "xī",
    meaning: "重视，不浪费，不随便丢弃珍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1511",
    type: "character",
    title: "豪",
    content: "豪",
    pronunciation: "háo",
    meaning: "卓越的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1512",
    type: "character",
    title: "掩",
    content: "掩",
    pronunciation: "yǎn",
    meaning: "遮蔽，遮盖",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1513",
    type: "character",
    title: "兼",
    content: "兼",
    pronunciation: "jiān",
    meaning: "几方面都有或几方都照顾到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1514",
    type: "character",
    title: "跃",
    content: "跃",
    pronunciation: "yuè",
    meaning: "跳跳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1515",
    type: "character",
    title: "尸",
    content: "尸",
    pronunciation: "shī",
    meaning: "死人的身体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1516",
    type: "character",
    title: "肃",
    content: "肃",
    pronunciation: "sù",
    meaning: "恭敬",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1517",
    type: "character",
    title: "帕",
    content: "帕",
    pronunciation: "pà",
    meaning: "包头或擦手或擦脸用的布、绸等包头",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1518",
    type: "character",
    title: "驶",
    content: "驶",
    pronunciation: "shǐ",
    meaning: "马快跑，跑疾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1519",
    type: "character",
    title: "堡",
    content: "堡",
    pronunciation: "bǎo",
    meaning: "关中堡壁三千余所。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1520",
    type: "character",
    title: "届",
    content: "届",
    pronunciation: "jiè",
    meaning: "至，到达",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1521",
    type: "character",
    title: "欣",
    content: "欣",
    pronunciation: "xīn",
    meaning: "又如欣惧(欣喜而惶恐);欣赞(欣喜赞美);欣欢(欣喜欢乐);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1522",
    type: "character",
    title: "惠",
    content: "惠",
    pronunciation: "huì",
    meaning: "好处，给人好处受",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1523",
    type: "character",
    title: "册",
    content: "册",
    pronunciation: "cè",
    meaning: "经传多以策为之,字俗作筴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1524",
    type: "character",
    title: "储",
    content: "储",
    pronunciation: "chǔ",
    meaning: "夸大,欺诳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1525",
    type: "character",
    title: "飘",
    content: "飘",
    pronunciation: "piāo",
    meaning: "旋风，大风",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1526",
    type: "character",
    title: "桑",
    content: "桑",
    pronunciation: "sānɡ",
    meaning: "一种桑属的落叶乔木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1527",
    type: "character",
    title: "闲",
    content: "闲",
    pronunciation: "xián",
    meaning: "没有事做空",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1528",
    type: "character",
    title: "惨",
    content: "惨",
    pronunciation: "cǎn",
    meaning: "又如惨虐(残酷暴虐);惨无人理(惨无人道)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1529",
    type: "character",
    title: "洁",
    content: "洁",
    pronunciation: "jié",
    meaning: "操行清白,品德高尚",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1530",
    type: "character",
    title: "踪",
    content: "踪",
    pronunciation: "zōnɡ",
    meaning: "脚印，踪迹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1531",
    type: "character",
    title: "勃",
    content: "勃",
    pronunciation: "bó",
    meaning: "又如勃郁(风回旋的样子;郁结);勃屑(即勃窣)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1532",
    type: "character",
    title: "宾",
    content: "宾",
    pronunciation: "bīn",
    meaning: "文及小篆易从止为从贝者,乃后起之字。本义地位尊贵、受人尊敬的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1533",
    type: "character",
    title: "频",
    content: "频",
    pronunciation: "pín",
    meaning: "屡次，连续多次",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1534",
    type: "character",
    title: "仇",
    content: "仇",
    pronunciation: "chóu",
    meaning: "又如仇忌(怨恨憎恶);仇嫌(怨仇;怨恨)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1535",
    type: "character",
    title: "磨",
    content: "磨",
    pronunciation: "mó",
    meaning: "摩擦",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1536",
    type: "character",
    title: "递",
    content: "递",
    pronunciation: "dì",
    meaning: "传;传送",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1537",
    type: "character",
    title: "邪",
    content: "邪",
    pronunciation: "xié",
    meaning: "不正当，不正派",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1538",
    type: "character",
    title: "撞",
    content: "撞",
    pronunciation: "zhuànɡ",
    meaning: "敲击",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1539",
    type: "character",
    title: "拟",
    content: "拟",
    pronunciation: "nǐ",
    meaning: "准备，打算",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1540",
    type: "character",
    title: "滚",
    content: "滚",
    pronunciation: "ɡǔn",
    meaning: "水流翻腾翻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1541",
    type: "character",
    title: "奏",
    content: "奏",
    pronunciation: "zòu",
    meaning: "作乐，按照曲调吹打乐器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1542",
    type: "character",
    title: "巡",
    content: "巡",
    pronunciation: "xún",
    meaning: "往来查看",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1543",
    type: "character",
    title: "颜",
    content: "颜",
    pronunciation: "yán",
    meaning: "印堂,两眉之间",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1544",
    type: "character",
    title: "剂",
    content: "剂",
    pronunciation: "jì",
    meaning: "调节;调和",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1545",
    type: "character",
    title: "绩",
    content: "绩",
    pronunciation: "jì",
    meaning: "勣）jì",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1546",
    type: "character",
    title: "贡",
    content: "贡",
    pronunciation: "ɡònɡ",
    meaning: "〈古〉将物品进献给皇帝进",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1547",
    type: "character",
    title: "疯",
    content: "疯",
    pronunciation: "fēnɡ",
    meaning: "神经错乱，精神失常",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1548",
    type: "character",
    title: "坡",
    content: "坡",
    pronunciation: "pō",
    meaning: "山的倾斜面，泛指倾斜的地方山",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1549",
    type: "character",
    title: "瞧",
    content: "瞧",
    pronunciation: "qiáo",
    meaning: "又如瞧女人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1550",
    type: "character",
    title: "截",
    content: "截",
    pronunciation: "jié",
    meaning: "切断，割断，弄断",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1551",
    type: "character",
    title: "燃",
    content: "燃",
    pronunciation: "rán",
    meaning: "引火点着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1552",
    type: "character",
    title: "焦",
    content: "焦",
    pronunciation: "jiāo",
    meaning: "物体经火烧变成炭样饭",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1553",
    type: "character",
    title: "殿",
    content: "殿",
    pronunciation: "diàn",
    meaning: "古代泛指高大的房屋,后专指供奉神佛或帝王受朝理事的大厅",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1554",
    type: "character",
    title: "伪",
    content: "伪",
    pronunciation: "wěi",
    meaning: "假，不真实",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1555",
    type: "character",
    title: "柳",
    content: "柳",
    pronunciation: "liǔ",
    meaning: "落叶乔木或灌木，枝条细长柔韧，叶狭长，花雌雄异株",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1556",
    type: "character",
    title: "锁",
    content: "锁",
    pronunciation: "suǒ",
    meaning: "安在门、箱、柜等的开合处，使人不能随便打开的器具铁",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1557",
    type: "character",
    title: "逼",
    content: "逼",
    pronunciation: "bī",
    meaning: "同本义(仅表示空间距离的接近、靠近)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1558",
    type: "character",
    title: "颇",
    content: "颇",
    pronunciation: "pō",
    meaning: "偏，偏差偏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1559",
    type: "character",
    title: "昏",
    content: "昏",
    pronunciation: "hūn",
    meaning: "天将黑，傍晚黄",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1560",
    type: "character",
    title: "劝",
    content: "劝",
    pronunciation: "quàn",
    meaning: "讲明事理，使人听从",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1561",
    type: "character",
    title: "呈",
    content: "呈",
    pronunciation: "chénɡ",
    meaning: "显出，露出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1562",
    type: "character",
    title: "搜",
    content: "搜",
    pronunciation: "sōu",
    meaning: "蒷）sōu",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1563",
    type: "character",
    title: "勤",
    content: "勤",
    pronunciation: "qín",
    meaning: "努力，尽力，跟\"懒\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1564",
    type: "character",
    title: "戒",
    content: "戒",
    pronunciation: "jiè",
    meaning: "防备",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1565",
    type: "character",
    title: "驾",
    content: "驾",
    pronunciation: "jià",
    meaning: "把车或农具等套在牲口身上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1566",
    type: "character",
    title: "漂",
    content: "漂",
    pronunciation: "piāo",
    meaning: "浮在液体面上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1567",
    type: "character",
    title: "饮",
    content: "饮",
    pronunciation: "yǐn",
    meaning: "同本义。有时特指喝酒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1568",
    type: "character",
    title: "曹",
    content: "曹",
    pronunciation: "cáo",
    meaning: "古代指诉讼的原告和被告。即两曹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1569",
    type: "character",
    title: "朵",
    content: "朵",
    pronunciation: "duǒ",
    meaning: "树木枝叶花实下垂貌。今指花朵,即植物的花或苞",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1570",
    type: "character",
    title: "仔",
    content: "仔",
    pronunciation: "zǎi",
    meaning: "指有某些特征或从事某种职业的年轻人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1571",
    type: "character",
    title: "柔",
    content: "柔",
    pronunciation: "róu",
    meaning: "软，嫩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1572",
    type: "character",
    title: "俩",
    content: "俩",
    pronunciation: "liǎnɡ",
    meaning: "两个，少数几个咱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1573",
    type: "character",
    title: "孟",
    content: "孟",
    pronunciation: "mènɡ",
    meaning: "旧时，兄弟姐妹排行用孟、仲、叔、季为序，孟是老大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1574",
    type: "character",
    title: "腐",
    content: "腐",
    pronunciation: "fǔ",
    meaning: "烂，臭败",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1575",
    type: "character",
    title: "幼",
    content: "幼",
    pronunciation: "yòu",
    meaning: "初生，年小，未长大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1576",
    type: "character",
    title: "践",
    content: "践",
    pronunciation: "jiàn",
    meaning: "踩，踏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1577",
    type: "character",
    title: "籍",
    content: "籍",
    pronunciation: "jí",
    meaning: "书，书册书",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1578",
    type: "character",
    title: "牧",
    content: "牧",
    pronunciation: "mù",
    meaning: "放养牲口",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1579",
    type: "character",
    title: "凉",
    content: "凉",
    pronunciation: "liánɡ",
    meaning: "稍冷，微寒，温度低",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1580",
    type: "character",
    title: "牲",
    content: "牲",
    pronunciation: "shēnɡ",
    meaning: "〈古〉指供祭祀和宴享用的牛羊猪，统称\"三牲\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1581",
    type: "character",
    title: "佳",
    content: "佳",
    pronunciation: "jiā",
    meaning: "美，好",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1582",
    type: "character",
    title: "娜",
    content: "娜",
    pronunciation: "nà",
    meaning: "见于人名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1583",
    type: "character",
    title: "浓",
    content: "浓",
    pronunciation: "nónɡ",
    meaning: "含某种成分多，跟\"淡\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1584",
    type: "character",
    title: "芳",
    content: "芳",
    pronunciation: "fānɡ",
    meaning: "花草的香味",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1585",
    type: "character",
    title: "稿",
    content: "稿",
    pronunciation: "ɡǎo",
    meaning: "稻、麦等植物的茎秆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1586",
    type: "character",
    title: "竹",
    content: "竹",
    pronunciation: "zhú",
    meaning: "多年生常绿植物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1587",
    type: "character",
    title: "腹",
    content: "腹",
    pronunciation: "fù",
    meaning: "肚子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1588",
    type: "character",
    title: "跌",
    content: "跌",
    pronunciation: "diē",
    meaning: "失足。喻指犯过失",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1589",
    type: "character",
    title: "逻",
    content: "逻",
    pronunciation: "luó",
    meaning: "巡察巡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1590",
    type: "character",
    title: "垂",
    content: "垂",
    pronunciation: "chuí",
    meaning: "通陲。边疆;边境",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1591",
    type: "character",
    title: "遵",
    content: "遵",
    pronunciation: "zūn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1592",
    type: "character",
    title: "脉",
    content: "脉",
    pronunciation: "mài",
    meaning: "血管动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1593",
    type: "character",
    title: "貌",
    content: "貌",
    pronunciation: "mào",
    meaning: "面容，长相面",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1594",
    type: "character",
    title: "柏",
    content: "柏",
    pronunciation: "bǎi",
    meaning: "特指柏台(御史台的别称『御史府中列植柏树,固称)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1595",
    type: "character",
    title: "狱",
    content: "狱",
    pronunciation: "yù",
    meaning: "监牢，监禁罪犯的场所监",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1596",
    type: "character",
    title: "猜",
    content: "猜",
    pronunciation: "cāi",
    meaning: "采取的计谋)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1597",
    type: "character",
    title: "怜",
    content: "怜",
    pronunciation: "lián",
    meaning: "同情",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1598",
    type: "character",
    title: "惑",
    content: "惑",
    pronunciation: "huò",
    meaning: "迷惘，怀疑，不明白迷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1599",
    type: "character",
    title: "陶",
    content: "陶",
    pronunciation: "táo",
    meaning: "用粘土烧制的器物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1600",
    type: "character",
    title: "兽",
    content: "兽",
    pronunciation: "shòu",
    meaning: "四足的哺乳动物,多指野兽",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1601",
    type: "character",
    title: "帐",
    content: "帐",
    pronunciation: "zhànɡ",
    meaning: "用布、纱、尼龙等做成的帷幕",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1602",
    type: "character",
    title: "饰",
    content: "饰",
    pronunciation: "shì",
    meaning: "装修得好看装",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1603",
    type: "character",
    title: "贷",
    content: "贷",
    pronunciation: "dài",
    meaning: "又如贷施(施舍);贷恤(赈施抚恤)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1604",
    type: "character",
    title: "昌",
    content: "昌",
    pronunciation: "chānɡ",
    meaning: "又如昌言(正直的善言、好话);昌教(善美的教化)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1605",
    type: "character",
    title: "叙",
    content: "叙",
    pronunciation: "xù",
    meaning: "说，谈，陈述",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1606",
    type: "character",
    title: "躺",
    content: "躺",
    pronunciation: "tǎnɡ",
    meaning: "身体横卧让他",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1607",
    type: "character",
    title: "钢",
    content: "钢",
    pronunciation: "ɡānɡ",
    meaning: "经过精炼的铁，含碳百分之0.15至百分之1.7,不含磷、硫等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1608",
    type: "character",
    title: "沟",
    content: "沟",
    pronunciation: "ɡōu",
    meaning: "田间的水沟，泛指小的流水道水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1609",
    type: "character",
    title: "寄",
    content: "寄",
    pronunciation: "jì",
    meaning: "依靠，依附",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1610",
    type: "character",
    title: "扶",
    content: "扶",
    pronunciation: "fú",
    meaning: "搀，用手支住、按着或把持着使不倒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1611",
    type: "character",
    title: "铺",
    content: "铺",
    pronunciation: "pù",
    meaning: "商店店",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1612",
    type: "character",
    title: "邓",
    content: "邓",
    pronunciation: "dènɡ",
    meaning: "在今河南省邓县。公元前678年为楚所灭",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1613",
    type: "character",
    title: "寿",
    content: "寿",
    pronunciation: "shòu",
    meaning: "生命的年限，又指岁数大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1614",
    type: "character",
    title: "惧",
    content: "惧",
    pronunciation: "jù",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1615",
    type: "character",
    title: "询",
    content: "询",
    pronunciation: "xún",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1616",
    type: "character",
    title: "汤",
    content: "汤",
    pronunciation: "tānɡ",
    meaning: "热水，开水赴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1617",
    type: "character",
    title: "盗",
    content: "盗",
    pronunciation: "dào",
    meaning: "眎,私利物也。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1618",
    type: "character",
    title: "肥",
    content: "肥",
    pronunciation: "féi",
    meaning: "含脂肪多，跟\"瘦\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1619",
    type: "character",
    title: "尝",
    content: "尝",
    pronunciation: "chánɡ",
    meaning: "辨别滋味",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1620",
    type: "character",
    title: "匆",
    content: "匆",
    pronunciation: "cōnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1621",
    type: "character",
    title: "辉",
    content: "辉",
    pronunciation: "huī",
    meaning: "闪耀的光彩光",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1622",
    type: "character",
    title: "奈",
    content: "奈",
    pronunciation: "nai",
    meaning: "如,如何",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1623",
    type: "character",
    title: "扣",
    content: "扣",
    pronunciation: "kòu",
    meaning: "釦）kòu",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1624",
    type: "character",
    title: "廷",
    content: "廷",
    pronunciation: "tínɡ",
    meaning: "封建时代君主受朝拜和处理政事的地方朝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1625",
    type: "character",
    title: "澳",
    content: "澳",
    pronunciation: "ào",
    meaning: "港湾,海边弯曲可以停船的地方",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1626",
    type: "character",
    title: "嘛",
    content: "嘛",
    pronunciation: "ma",
    meaning: "表示道理显而易见",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1627",
    type: "character",
    title: "董",
    content: "董",
    pronunciation: "dǒnɡ",
    meaning: "监督;督察",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1628",
    type: "character",
    title: "迁",
    content: "迁",
    pronunciation: "qiān",
    meaning: "搬移，换地点",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1629",
    type: "character",
    title: "凝",
    content: "凝",
    pronunciation: "nínɡ",
    meaning: "物体由气体变为液体或液体变为固体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1630",
    type: "character",
    title: "慰",
    content: "慰",
    pronunciation: "wèi",
    meaning: "安抚招纳或接纳)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1631",
    type: "character",
    title: "厌",
    content: "厌",
    pronunciation: "yàn",
    meaning: "憎恶，烦腻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1632",
    type: "character",
    title: "脏",
    content: "脏",
    pronunciation: "zānɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1633",
    type: "character",
    title: "腾",
    content: "腾",
    pronunciation: "ténɡ",
    meaning: "跳跃虎",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1634",
    type: "character",
    title: "幽",
    content: "幽",
    pronunciation: "yōu",
    meaning: "僻静，阴暗，深暗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1635",
    type: "character",
    title: "怨",
    content: "怨",
    pronunciation: "yuàn",
    meaning: "不满，责备",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1636",
    type: "character",
    title: "鞋",
    content: "鞋",
    pronunciation: "xié",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1637",
    type: "character",
    title: "丢",
    content: "丢",
    pronunciation: "diu1",
    meaning: "抛弃;撇开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1638",
    type: "character",
    title: "埋",
    content: "埋",
    pronunciation: "mái",
    meaning: "将东西放在坑里用土盖上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1639",
    type: "character",
    title: "泉",
    content: "泉",
    pronunciation: "quán",
    meaning: "从地下涌出来的水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1640",
    type: "character",
    title: "涌",
    content: "涌",
    pronunciation: "yǒnɡ",
    meaning: "水从下向上冒出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1641",
    type: "character",
    title: "辖",
    content: "辖",
    pronunciation: "xiá",
    meaning: "车上的部件，用于挡住车轮，不使脱落车",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1642",
    type: "character",
    title: "躲",
    content: "躲",
    pronunciation: "duǒ",
    meaning: "避开;避让",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1643",
    type: "character",
    title: "晋",
    content: "晋",
    pronunciation: "jìn",
    meaning: "进，升，向前",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1644",
    type: "character",
    title: "紫",
    content: "紫",
    pronunciation: "zǐ",
    meaning: "红与蓝合成的颜色万",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1645",
    type: "character",
    title: "艰",
    content: "艰",
    pronunciation: "jiān",
    meaning: "困难",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1646",
    type: "character",
    title: "魏",
    content: "魏",
    pronunciation: "wèi",
    meaning: "周代诸侯国名，战国时期七雄之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1647",
    type: "character",
    title: "吾",
    content: "吾",
    pronunciation: "wú",
    meaning: "不吾知也。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1648",
    type: "character",
    title: "慌",
    content: "慌",
    pronunciation: "huānɡ",
    meaning: "急，忙乱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1649",
    type: "character",
    title: "祝",
    content: "祝",
    pronunciation: "zhù",
    meaning: "〈表〉良好的愿望",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1650",
    type: "character",
    title: "邮",
    content: "邮",
    pronunciation: "yóu",
    meaning: "寄递信件、金钱、物品等的专设机构、人员",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1651",
    type: "character",
    title: "吐",
    content: "吐",
    pronunciation: "tǔ",
    meaning: "使东西从嘴里出来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1652",
    type: "character",
    title: "狠",
    content: "狠",
    pronunciation: "hěn",
    meaning: "凶恶，残忍凶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1653",
    type: "character",
    title: "鉴",
    content: "鉴",
    pronunciation: "jiàn",
    meaning: "〈古〉用来盛水或冰的大盆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1654",
    type: "character",
    title: "曰",
    content: "曰",
    pronunciation: "yuē",
    meaning: "说孔子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1655",
    type: "character",
    title: "械",
    content: "械",
    pronunciation: "xiè",
    meaning: "家伙，器物机",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1656",
    type: "character",
    title: "咬",
    content: "咬",
    pronunciation: "yǎo",
    meaning: "用牙齿夹住或夹碎东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1657",
    type: "character",
    title: "邻",
    content: "邻",
    pronunciation: "lín",
    meaning: "接近的，住处靠近的人家",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1658",
    type: "character",
    title: "赤",
    content: "赤",
    pronunciation: "chì",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1659",
    type: "character",
    title: "挤",
    content: "挤",
    pronunciation: "jǐ",
    meaning: "用力压使排出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1660",
    type: "character",
    title: "弯",
    content: "弯",
    pronunciation: "wān",
    meaning: "屈曲，不直",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1661",
    type: "character",
    title: "椅",
    content: "椅",
    pronunciation: "yǐ",
    meaning: "木名。即山桐子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1662",
    type: "character",
    title: "陪",
    content: "陪",
    pronunciation: "péi",
    meaning: "伴随",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1663",
    type: "character",
    title: "割",
    content: "割",
    pronunciation: "ɡē",
    meaning: "切下，截断",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1664",
    type: "character",
    title: "揭",
    content: "揭",
    pronunciation: "jiē",
    meaning: "举，高举",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1665",
    type: "character",
    title: "韦",
    content: "韦",
    pronunciation: "wéi",
    meaning: "熟皮,去毛熟治的皮革",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1666",
    type: "character",
    title: "悟",
    content: "悟",
    pronunciation: "wù",
    meaning: "理解，领会，明白领",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1667",
    type: "character",
    title: "聪",
    content: "聪",
    pronunciation: "cōnɡ",
    meaning: "又如聪耳(听觉灵敏的耳朵)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1668",
    type: "character",
    title: "雾",
    content: "雾",
    pronunciation: "wù",
    meaning: "飘浮在近地面空气中的大量小水滴或冰晶，主要是水蒸气遇冷后凝结",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1669",
    type: "character",
    title: "锋",
    content: "锋",
    pronunciation: "fēnɡ",
    meaning: "刀、剑等兵器的锐利部分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1670",
    type: "character",
    title: "梯",
    content: "梯",
    pronunciation: "tī",
    meaning: "登上、到下使用的器具或设备",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1671",
    type: "character",
    title: "猫",
    content: "猫",
    pronunciation: "māo",
    meaning: "家猫,久已被人类驯养的一种食肉类动物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1672",
    type: "character",
    title: "祥",
    content: "祥",
    pronunciation: "xiánɡ",
    meaning: "吉利吉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1673",
    type: "character",
    title: "阔",
    content: "阔",
    pronunciation: "kuò",
    meaning: "宽广宽",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1674",
    type: "character",
    title: "誉",
    content: "誉",
    pronunciation: "yù",
    meaning: "名声名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1675",
    type: "character",
    title: "筹",
    content: "筹",
    pronunciation: "chóu",
    meaning: "计数的用具",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1676",
    type: "character",
    title: "丛",
    content: "丛",
    pronunciation: "cónɡ",
    meaning: "许多事物凑在一起",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1677",
    type: "character",
    title: "牵",
    content: "牵",
    pronunciation: "qiān",
    meaning: "拉,挽着,挽引向前",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1678",
    type: "character",
    title: "鸣",
    content: "鸣",
    pronunciation: "mínɡ",
    meaning: "禽兽或虫叫鸡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1679",
    type: "character",
    title: "沈",
    content: "沈",
    pronunciation: "shěn",
    meaning: "没入水中，跟\"浮\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1680",
    type: "character",
    title: "阁",
    content: "阁",
    pronunciation: "ɡé",
    meaning: "楼房的一种，一般两层，周围开窗，供游息、藏书等用亭台楼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1681",
    type: "character",
    title: "穆",
    content: "穆",
    pronunciation: "mù",
    meaning: "和畅，美好",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1682",
    type: "character",
    title: "屈",
    content: "屈",
    pronunciation: "qū",
    meaning: "弯曲，跟伸相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1683",
    type: "character",
    title: "旨",
    content: "旨",
    pronunciation: "zhǐ",
    meaning: "意义，意图，目的意",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1684",
    type: "character",
    title: "袖",
    content: "袖",
    pronunciation: "xiù",
    meaning: "袖子，衣服套在胳膊上的部分衣",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1685",
    type: "character",
    title: "猎",
    content: "猎",
    pronunciation: "liè",
    meaning: "捕捉禽兽打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1686",
    type: "character",
    title: "臂",
    content: "臂",
    pronunciation: "bì",
    meaning: "又如臂缚(古时缚在两臂以抵御兵刃的铠甲。也称臂手);臂纱(缠",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1687",
    type: "character",
    title: "蛇",
    content: "蛇",
    pronunciation: "shé",
    meaning: "又如蛇豕(比喻贪婪残暴的人);蛇虺(喻指阴狠毒辣的人);蛇食",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1688",
    type: "character",
    title: "贺",
    content: "贺",
    pronunciation: "hè",
    meaning: "奉送礼物表示庆祝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1689",
    type: "character",
    title: "柱",
    content: "柱",
    pronunciation: "zhù",
    meaning: "支撑建筑物的构件木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1690",
    type: "character",
    title: "抛",
    content: "抛",
    pronunciation: "pāo",
    meaning: "投，扔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1691",
    type: "character",
    title: "鼠",
    content: "鼠",
    pronunciation: "shǔ",
    meaning: ");鼠布(以鼠毛制成的布);鼠裘(用鼠皮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1692",
    type: "character",
    title: "瑟",
    content: "瑟",
    pronunciation: "sè",
    meaning: "拨弦乐器之一，一般有二十五根弦",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1693",
    type: "character",
    title: "戈",
    content: "戈",
    pronunciation: "ɡē",
    meaning: "中国古代的主要兵器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1694",
    type: "character",
    title: "牢",
    content: "牢",
    pronunciation: "láo",
    meaning: "饲养牲畜的栏圈亡羊补",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1695",
    type: "character",
    title: "逊",
    content: "逊",
    pronunciation: "xùn",
    meaning: "让，退让唐尧",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1696",
    type: "character",
    title: "迈",
    content: "迈",
    pronunciation: "mài",
    meaning: "行，去长",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1697",
    type: "character",
    title: "欺",
    content: "欺",
    pronunciation: "qī",
    meaning: "骗，蒙混",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1698",
    type: "character",
    title: "吨",
    content: "吨",
    pronunciation: "dūn",
    meaning: "质量和重量的单位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1699",
    type: "character",
    title: "琴",
    content: "琴",
    pronunciation: "qín",
    meaning: "拨弦乐器，俗称\"古琴\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1700",
    type: "character",
    title: "衰",
    content: "衰",
    pronunciation: "shuāi",
    meaning: "微弱，事物发展转向微弱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1701",
    type: "character",
    title: "瓶",
    content: "瓶",
    pronunciation: "pínɡ",
    meaning: "古代比缶小的容器,用以汲水,也用以盛酒食",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1702",
    type: "character",
    title: "恼",
    content: "恼",
    pronunciation: "nǎo",
    meaning: "忿恨，发怒可",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1703",
    type: "character",
    title: "燕",
    content: "燕",
    pronunciation: "yàn",
    meaning: "燕子，翼尖而长，尾巴叉状像张开的剪刀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1704",
    type: "character",
    title: "仲",
    content: "仲",
    pronunciation: "zhònɡ",
    meaning: "兄弟排行次序",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1705",
    type: "character",
    title: "诱",
    content: "诱",
    pronunciation: "yòu",
    meaning: "引导，教导，劝导",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1706",
    type: "character",
    title: "狼",
    content: "狼",
    pronunciation: "lánɡ",
    meaning: "野兽之一，形状像狗，但嘴较尖，耳朵直立，尾巴下垂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1707",
    type: "character",
    title: "池",
    content: "池",
    pronunciation: "chí",
    meaning: "水塘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1708",
    type: "character",
    title: "疼",
    content: "疼",
    pronunciation: "ténɡ",
    meaning: "同本义 (仅表示身体上的难受)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1709",
    type: "character",
    title: "卢",
    content: "卢",
    pronunciation: "lú",
    meaning: "黑色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1710",
    type: "character",
    title: "仗",
    content: "仗",
    pronunciation: "zhànɡ",
    meaning: "又如仗斧(手持斧铖钺。表示权威);仗节(手持符节;坚守节操)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1711",
    type: "character",
    title: "冠",
    content: "冠",
    pronunciation: "ɡuàn",
    meaning: "〈古〉一种礼仪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1712",
    type: "character",
    title: "粒",
    content: "粒",
    pronunciation: "lì",
    meaning: "小颗的，小碎块的米",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1713",
    type: "character",
    title: "遥",
    content: "遥",
    pronunciation: "yáo",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1714",
    type: "character",
    title: "吕",
    content: "吕",
    pronunciation: "lǚ",
    meaning: "同本义。膂的古字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1715",
    type: "character",
    title: "玄",
    content: "玄",
    pronunciation: "xuán",
    meaning: "黑中带红，泛指黑",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1716",
    type: "character",
    title: "尘",
    content: "尘",
    pronunciation: "chén",
    meaning: "飞扬的或浮面的灰土",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1717",
    type: "character",
    title: "冯",
    content: "冯",
    pronunciation: "fénɡ",
    meaning: "又如冯冯(马行疾速的样子)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1718",
    type: "character",
    title: "抚",
    content: "抚",
    pronunciation: "fǔ",
    meaning: "扶持，保护，养育",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1719",
    type: "character",
    title: "浅",
    content: "浅",
    pronunciation: "qiǎn",
    meaning: "通践。实行,实现",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1720",
    type: "character",
    title: "敦",
    content: "敦",
    pronunciation: "dūn",
    meaning: "厚道。诚朴宽厚;厚重;笃实",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1721",
    type: "character",
    title: "纠",
    content: "纠",
    pronunciation: "jiū",
    meaning: "绳子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1722",
    type: "character",
    title: "钻",
    content: "钻",
    pronunciation: "zuàn",
    meaning: "穿孔，打眼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1723",
    type: "character",
    title: "晶",
    content: "晶",
    pronunciation: "jīnɡ",
    meaning: "形容透明、光亮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1724",
    type: "character",
    title: "岂",
    content: "岂",
    pronunciation: "qǐ",
    meaning: "助词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1725",
    type: "character",
    title: "峡",
    content: "峡",
    pronunciation: "xiá",
    meaning: "两面有山夹着的水道长江三",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1726",
    type: "character",
    title: "苍",
    content: "苍",
    pronunciation: "cānɡ",
    meaning: "同本义,引申为青黑色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1727",
    type: "character",
    title: "喷",
    content: "喷",
    pronunciation: "pēn",
    meaning: "散着射出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1728",
    type: "character",
    title: "耗",
    content: "耗",
    pronunciation: "hào",
    meaning: "亏损，消费损",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1729",
    type: "character",
    title: "凌",
    content: "凌",
    pronunciation: "línɡ",
    meaning: "聆〈动〉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1730",
    type: "character",
    title: "敲",
    content: "敲",
    pronunciation: "qiāo",
    meaning: "击，打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1731",
    type: "character",
    title: "菌",
    content: "菌",
    pronunciation: "jūn",
    meaning: "组成裂殖菌纲的一大类微小植物中的任一种",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1732",
    type: "character",
    title: "赔",
    content: "赔",
    pronunciation: "péi",
    meaning: "补还损失",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1733",
    type: "character",
    title: "涂",
    content: "涂",
    pronunciation: "tú",
    meaning: "抹刷，粉饰",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1734",
    type: "character",
    title: "粹",
    content: "粹",
    pronunciation: "cuì",
    meaning: "不含添加、替代或异质物质的;纯的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1735",
    type: "character",
    title: "扁",
    content: "扁",
    pronunciation: "biǎn",
    meaning: "又如扁表(题门表彰)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1736",
    type: "character",
    title: "亏",
    content: "亏",
    pronunciation: "kuī",
    meaning: "欠缺，短少",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1737",
    type: "character",
    title: "寂",
    content: "寂",
    pronunciation: "jì",
    meaning: "没有声音",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1738",
    type: "character",
    title: "煤",
    content: "煤",
    pronunciation: "méi",
    meaning: "也叫\"煤炭\"或\"石炭\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1739",
    type: "character",
    title: "熊",
    content: "熊",
    pronunciation: "xiónɡ",
    meaning: "属国家保护的哺乳动物，严禁猎杀食用",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1740",
    type: "character",
    title: "恭",
    content: "恭",
    pronunciation: "ɡōnɡ",
    meaning: "敬重，谦逊",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1741",
    type: "character",
    title: "湿",
    content: "湿",
    pronunciation: "shī",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1742",
    type: "character",
    title: "循",
    content: "循",
    pronunciation: "xún",
    meaning: "顺着，遵照，沿袭",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1743",
    type: "character",
    title: "暖",
    content: "暖",
    pronunciation: "nuǎn",
    meaning: "温和，不冷也不热",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1744",
    type: "character",
    title: "糖",
    content: "糖",
    pronunciation: "tánɡ",
    meaning: "醣）táng",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1745",
    type: "character",
    title: "赋",
    content: "赋",
    pronunciation: "fù",
    meaning: "赋税",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1746",
    type: "character",
    title: "抑",
    content: "抑",
    pronunciation: "yì",
    meaning: "按，向下压跟\"扬\"相对高者",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1747",
    type: "character",
    title: "秩",
    content: "秩",
    pronunciation: "zhì",
    meaning: "次序，有条理，不紊乱依",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1748",
    type: "character",
    title: "帽",
    content: "帽",
    pronunciation: "mào",
    meaning: "帽子，帽儿，戴在头上的缝纫物或编织物棉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1749",
    type: "character",
    title: "哀",
    content: "哀",
    pronunciation: "āi",
    meaning: "悲伤，悲痛悲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1750",
    type: "character",
    title: "宿",
    content: "宿",
    pronunciation: "xiǔ",
    meaning: "住，过夜，夜晚睡觉住",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1751",
    type: "character",
    title: "踏",
    content: "踏",
    pronunciation: "tà",
    meaning: "踩践",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1752",
    type: "character",
    title: "烂",
    content: "烂",
    pronunciation: "làn",
    meaning: "稀软",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1753",
    type: "character",
    title: "袁",
    content: "袁",
    pronunciation: "yuán",
    meaning: "长衣的样子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1754",
    type: "character",
    title: "侯",
    content: "侯",
    pronunciation: "hòu",
    meaning: "〈古〉五等爵位的第二等公",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1755",
    type: "character",
    title: "抖",
    content: "抖",
    pronunciation: "dǒu",
    meaning: "振动;甩动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1756",
    type: "character",
    title: "夹",
    content: "夹",
    pronunciation: "jiā",
    meaning: "又如夹拥(左右围抱)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1757",
    type: "character",
    title: "昆",
    content: "昆",
    pronunciation: "kūn",
    meaning: "崑）kūn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1758",
    type: "character",
    title: "肝",
    content: "肝",
    pronunciation: "ɡān",
    meaning: "肝脏，人和高等动物重要器官之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1759",
    type: "character",
    title: "擦",
    content: "擦",
    pronunciation: "cā",
    meaning: "又如他用手帕擦鼻子;擦脸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1760",
    type: "character",
    title: "猪",
    content: "猪",
    pronunciation: "zhū",
    meaning: "达,热时喜浸水散热;特指家养种的成员",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1761",
    type: "character",
    title: "炼",
    content: "炼",
    pronunciation: "liàn",
    meaning: "用加热法制做",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1762",
    type: "character",
    title: "恒",
    content: "恒",
    pronunciation: "hénɡ",
    meaning: "经常，常常，一般",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1763",
    type: "character",
    title: "慎",
    content: "慎",
    pronunciation: "shèn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1764",
    type: "character",
    title: "搬",
    content: "搬",
    pronunciation: "bān",
    meaning: "又如搬起石头打自己的脚;把货物搬走;他早就搬走了;搬场(迁居",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1765",
    type: "character",
    title: "纽",
    content: "纽",
    pronunciation: "niǔ",
    meaning: "器物上可以提起来或系挂的部分秤",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1766",
    type: "character",
    title: "纹",
    content: "纹",
    pronunciation: "wén",
    meaning: "又如纹杇(丝织品的皱纹,常用来形容水波)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1767",
    type: "character",
    title: "玻",
    content: "玻",
    pronunciation: "bō",
    meaning: "等于这两种定态的能量差；（3）原子的不同能量状态跟电子沿不同",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1768",
    type: "character",
    title: "渔",
    content: "渔",
    pronunciation: "yú",
    meaning: "又如渔色渔财(猎取美女和财物);渔猎女色(似捕鱼打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1769",
    type: "character",
    title: "磁",
    content: "磁",
    pronunciation: "cí",
    meaning: "同本义。也为石名,即磁石,俗称吸铁石",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1770",
    type: "character",
    title: "铜",
    content: "铜",
    pronunciation: "tónɡ",
    meaning: "首衔同凡。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1771",
    type: "character",
    title: "齿",
    content: "齿",
    pronunciation: "chǐ",
    meaning: "门牙，泛指牙齿唇",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1772",
    type: "character",
    title: "跨",
    content: "跨",
    pronunciation: "kuà",
    meaning: "抬起一条腿越过、向前或往旁边移动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1773",
    type: "character",
    title: "押",
    content: "押",
    pronunciation: "yā",
    meaning: "在文书、契约上签字或画记号，以做凭证签",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1774",
    type: "character",
    title: "怖",
    content: "怖",
    pronunciation: "bù",
    meaning: "吾畏其卒,故怖其始。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1775",
    type: "character",
    title: "漠",
    content: "漠",
    pronunciation: "mò",
    meaning: "地面为沙石覆盖，干燥缺水，不生植物或植物稀少的地区沙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1776",
    type: "character",
    title: "疲",
    content: "疲",
    pronunciation: "pí",
    meaning: "累，劳累，倦怠，乏力",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1777",
    type: "character",
    title: "叛",
    content: "叛",
    pronunciation: "pàn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1778",
    type: "character",
    title: "遣",
    content: "遣",
    pronunciation: "qiǎn",
    meaning: "差，派差",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1779",
    type: "character",
    title: "兹",
    content: "兹",
    pronunciation: "zī",
    meaning: "此，这，这个，这样",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1780",
    type: "character",
    title: "祭",
    content: "祭",
    pronunciation: "jì",
    meaning: "〈表〉对死者追悼、敬意的仪式",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1781",
    type: "character",
    title: "醉",
    content: "醉",
    pronunciation: "zuì",
    meaning: "饮酒过量或药物作用，致使神志不清或暂时失去知觉酒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1782",
    type: "character",
    title: "拳",
    content: "拳",
    pronunciation: "quán",
    meaning: "屈指卷握起来的手",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1783",
    type: "character",
    title: "弥",
    content: "弥",
    pronunciation: "mí",
    meaning: "满，遍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1784",
    type: "character",
    title: "斜",
    content: "斜",
    pronunciation: "xié",
    meaning: "歪，不正",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1785",
    type: "character",
    title: "档",
    content: "档",
    pronunciation: "dànɡ",
    meaning: "又如床档;十三档算盘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1786",
    type: "character",
    title: "稀",
    content: "稀",
    pronunciation: "xī",
    meaning: "疏，跟\"密\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1787",
    type: "character",
    title: "捷",
    content: "捷",
    pronunciation: "jié",
    meaning: "胜利，成功",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1788",
    type: "character",
    title: "肤",
    content: "肤",
    pronunciation: "fū",
    meaning: "树木、果实的表皮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1789",
    type: "character",
    title: "疫",
    content: "疫",
    pronunciation: "yì",
    meaning: "同本义。急性传染病流行的通称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1790",
    type: "character",
    title: "肿",
    content: "肿",
    pronunciation: "zhǒnɡ",
    meaning: "浮胀;肿胀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1791",
    type: "character",
    title: "豆",
    content: "豆",
    pronunciation: "dòu",
    meaning: "于豆于登。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1792",
    type: "character",
    title: "削",
    content: "削",
    pronunciation: "xuē",
    meaning: "用刀平着切去切",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1793",
    type: "character",
    title: "岗",
    content: "岗",
    pronunciation: "ɡǎnɡ",
    meaning: "守卫的位置站",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1794",
    type: "character",
    title: "晃",
    content: "晃",
    pronunciation: "huànɡ",
    meaning: "照耀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1795",
    type: "character",
    title: "吞",
    content: "吞",
    pronunciation: "tūn",
    meaning: "不嚼或不细嚼，整个咽下去",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1796",
    type: "character",
    title: "宏",
    content: "宏",
    pronunciation: "hónɡ",
    meaning: "大;宏大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1797",
    type: "character",
    title: "癌",
    content: "癌",
    pronunciation: "ái",
    meaning: "来源于上皮组织的恶性肿瘤胃",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1798",
    type: "character",
    title: "肚",
    content: "肚",
    pronunciation: "dù",
    meaning: "物体突起或中间鼓出的部分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1799",
    type: "character",
    title: "隶",
    content: "隶",
    pronunciation: "lì",
    meaning: "附属，属于",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1800",
    type: "character",
    title: "履",
    content: "履",
    pronunciation: "lǚ",
    meaning: "鞋草",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1801",
    type: "character",
    title: "涨",
    content: "涨",
    pronunciation: "zhǎnɡ",
    meaning: "水量增大，水面高起来河水暴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1802",
    type: "character",
    title: "耀",
    content: "耀",
    pronunciation: "yào",
    meaning: "光线照射阳光照",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1803",
    type: "character",
    title: "扭",
    content: "扭",
    pronunciation: "niǔ",
    meaning: "转动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1804",
    type: "character",
    title: "坛",
    content: "坛",
    pronunciation: "tán",
    meaning: "祀用的土台和坑穴)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1805",
    type: "character",
    title: "拨",
    content: "拨",
    pronunciation: "bō",
    meaning: "又如拨风(像拨开大风的样子,速度异常之快);拨火儿(拨",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1806",
    type: "character",
    title: "沃",
    content: "沃",
    pronunciation: "wò",
    meaning: "土地肥",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1807",
    type: "character",
    title: "绘",
    content: "绘",
    pronunciation: "huì",
    meaning: "又如绘绚(彩绘绚丽)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1808",
    type: "character",
    title: "伐",
    content: "伐",
    pronunciation: "fá",
    meaning: "砍砍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1809",
    type: "character",
    title: "堪",
    content: "堪",
    pronunciation: "kān",
    meaning: "忍受，经得起难",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1810",
    type: "character",
    title: "仆",
    content: "仆",
    pronunciation: "pú",
    meaning: "被雇用于做杂事、供役使的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1811",
    type: "character",
    title: "郭",
    content: "郭",
    pronunciation: "ɡuō",
    meaning: "城外围加筑的一道城墙东",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1812",
    type: "character",
    title: "牺",
    content: "牺",
    pronunciation: "xī",
    meaning: "〈古〉作祭品用的纯毛色的牲畜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1813",
    type: "character",
    title: "歼",
    content: "歼",
    pronunciation: "jiān",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1814",
    type: "character",
    title: "墓",
    content: "墓",
    pronunciation: "mù",
    meaning: "同本义◇不加区别,统称作墓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1815",
    type: "character",
    title: "雇",
    content: "雇",
    pronunciation: "ɡù",
    meaning: "出钱叫人为自己做事",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1816",
    type: "character",
    title: "廉",
    content: "廉",
    pronunciation: "lián",
    meaning: "不贪污",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1817",
    type: "character",
    title: "契",
    content: "契",
    pronunciation: "qì",
    meaning: "合同，契约地",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1818",
    type: "character",
    title: "拼",
    content: "拼",
    pronunciation: "pīn",
    meaning: "连合，凑合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1819",
    type: "character",
    title: "惩",
    content: "惩",
    pronunciation: "chénɡ",
    meaning: "警戒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1820",
    type: "character",
    title: "捉",
    content: "捉",
    pronunciation: "zhuō",
    meaning: "⒈握～枪。～笔赋诗。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1821",
    type: "character",
    title: "刷",
    content: "刷",
    pronunciation: "shuā",
    meaning: "清除或涂抹东西的用具，用成束的毛、棕或尼龙等制成牙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1822",
    type: "character",
    title: "劫",
    content: "劫",
    pronunciation: "jié",
    meaning: "强夺，掠取",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1823",
    type: "character",
    title: "嫌",
    content: "嫌",
    pronunciation: "xián",
    meaning: "疑惑，疑忌",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1824",
    type: "character",
    title: "瓜",
    content: "瓜",
    pronunciation: "ɡuā",
    meaning: "葫芦科植物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1825",
    type: "character",
    title: "歇",
    content: "歇",
    pronunciation: "xiē",
    meaning: "休息",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1826",
    type: "character",
    title: "雕",
    content: "雕",
    pronunciation: "diāo",
    meaning: "同碉。碉堡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1827",
    type: "character",
    title: "闷",
    content: "闷",
    pronunciation: "mèn",
    meaning: "气压低或空气不流通等引起的不舒服",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1828",
    type: "character",
    title: "乳",
    content: "乳",
    pronunciation: "rǔ",
    meaning: "分泌奶汁的器官",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1829",
    type: "character",
    title: "串",
    content: "串",
    pronunciation: "chuàn",
    meaning: "连贯，连贯成行的贯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1830",
    type: "character",
    title: "娃",
    content: "娃",
    pronunciation: "wá",
    meaning: "小孩乖",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1831",
    type: "character",
    title: "缴",
    content: "缴",
    pronunciation: "jiǎo",
    meaning: "交出，交纳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1832",
    type: "character",
    title: "唤",
    content: "唤",
    pronunciation: "huàn",
    meaning: "又如唤门(在门外叫内边的人开门);唤应(呼应,照应);唤字叫",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1833",
    type: "character",
    title: "赢",
    content: "赢",
    pronunciation: "yínɡ",
    meaning: "获利，利润",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1834",
    type: "character",
    title: "莲",
    content: "莲",
    pronunciation: "lián",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1835",
    type: "character",
    title: "霸",
    content: "霸",
    pronunciation: "bà",
    meaning: "假借为伯。指古代诸侯联盟的盟主",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1836",
    type: "character",
    title: "桃",
    content: "桃",
    pronunciation: "táo",
    meaning: "桃树，落叶乔木，春天开红色或白色的花",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1837",
    type: "character",
    title: "妥",
    content: "妥",
    pronunciation: "tuǒ",
    meaning: "恰当，合适",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1838",
    type: "character",
    title: "瘦",
    content: "瘦",
    pronunciation: "shòu",
    meaning: "体内脂肪少，肌肉不丰，跟\"肥\"相对他太",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1839",
    type: "character",
    title: "搭",
    content: "搭",
    pronunciation: "dā",
    meaning: "又如搭面(抽打面部);扑搭;搭墩(跌坐)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1840",
    type: "character",
    title: "赴",
    content: "赴",
    pronunciation: "fù",
    meaning: "又如赴履(奔赴);赴质(奔赴目标);赴助(赴救);赴急(往救",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1841",
    type: "character",
    title: "岳",
    content: "岳",
    pronunciation: "yuè",
    meaning: "高大的山五",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1842",
    type: "character",
    title: "嘉",
    content: "嘉",
    pronunciation: "jiā",
    meaning: "好的，美好的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1843",
    type: "character",
    title: "舱",
    content: "舱",
    pronunciation: "cānɡ",
    meaning: "船或飞机中分隔开来载人或装东西的部分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1844",
    type: "character",
    title: "俊",
    content: "俊",
    pronunciation: "jùn",
    meaning: "隽jùn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1845",
    type: "character",
    title: "址",
    content: "址",
    pronunciation: "zhǐ",
    meaning: "地点;地址;处所",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1846",
    type: "character",
    title: "庞",
    content: "庞",
    pronunciation: "pánɡ",
    meaning: "大，高大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1847",
    type: "character",
    title: "耕",
    content: "耕",
    pronunciation: "ɡēnɡ",
    meaning: "翻松泥土春",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1848",
    type: "character",
    title: "锐",
    content: "锐",
    pronunciation: "ruì",
    meaning: "快或尖，跟\"钝\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1849",
    type: "character",
    title: "缝",
    content: "缝",
    pronunciation: "fénɡ",
    meaning: "裂开的或自然显露的窄长口子一条裂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1850",
    type: "character",
    title: "悔",
    content: "悔",
    pronunciation: "huǐ",
    meaning: "做错事后埋怨、懊恼或怨恨后",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1851",
    type: "character",
    title: "邀",
    content: "邀",
    pronunciation: "yāo",
    meaning: "约，请",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1852",
    type: "character",
    title: "玲",
    content: "玲",
    pronunciation: "línɡ",
    meaning: "象声词。玉声",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1853",
    type: "character",
    title: "惟",
    content: "惟",
    pronunciation: "wéi",
    meaning: "思，考虑思",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1854",
    type: "character",
    title: "斥",
    content: "斥",
    pronunciation: "chì",
    meaning: "使退去，使离去",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1855",
    type: "character",
    title: "宅",
    content: "宅",
    pronunciation: "zhái",
    meaning: "家,常指大家族的家",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1856",
    type: "character",
    title: "添",
    content: "添",
    pronunciation: "tiān",
    meaning: "如添嘴送舌(添言加语;搬弄是非);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1857",
    type: "character",
    title: "挖",
    content: "挖",
    pronunciation: "wā",
    meaning: "掏，掘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1858",
    type: "character",
    title: "呵",
    content: "呵",
    pronunciation: "hē",
    meaning: "怒斥，大声喝斥",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1859",
    type: "character",
    title: "讼",
    content: "讼",
    pronunciation: "sònɡ",
    meaning: "争论，争辩辩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1860",
    type: "character",
    title: "氧",
    content: "氧",
    pronunciation: "yǎnɡ",
    meaning: "素符号o",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1861",
    type: "character",
    title: "浩",
    content: "浩",
    pronunciation: "hào",
    meaning: "广大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1862",
    type: "character",
    title: "羽",
    content: "羽",
    pronunciation: "yǔ",
    meaning: "鸟翅膀上的长毛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1863",
    type: "character",
    title: "斤",
    content: "斤",
    pronunciation: "jīn",
    meaning: "重量单位市制一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1864",
    type: "character",
    title: "酷",
    content: "酷",
    pronunciation: "kù",
    meaning: "凶残，暴虐残",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1865",
    type: "character",
    title: "掠",
    content: "掠",
    pronunciation: "lüě",
    meaning: "抢劫，夺取",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1866",
    type: "character",
    title: "妖",
    content: "妖",
    pronunciation: "yāo",
    meaning: "神话传说或迷信者称\"异常而且害人的怪物\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1867",
    type: "character",
    title: "祸",
    content: "祸",
    pronunciation: "huò",
    meaning: "灾害，苦难，跟\"福\"相对闯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1868",
    type: "character",
    title: "侍",
    content: "侍",
    pronunciation: "shì",
    meaning: "引申为服侍、侍奉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1869",
    type: "character",
    title: "乙",
    content: "乙",
    pronunciation: "yǐ",
    meaning: "天干第二位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1870",
    type: "character",
    title: "妨",
    content: "妨",
    pronunciation: "fánɡ",
    meaning: "阻碍，损害",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1871",
    type: "character",
    title: "贪",
    content: "贪",
    pronunciation: "tān",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1872",
    type: "character",
    title: "挣",
    content: "挣",
    pronunciation: "zhènɡ",
    meaning: "用力支撑或摆脱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1873",
    type: "character",
    title: "汪",
    content: "汪",
    pronunciation: "wānɡ",
    meaning: "深广一片",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1874",
    type: "character",
    title: "尿",
    content: "尿",
    pronunciation: "niào",
    meaning: "小便屙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1875",
    type: "character",
    title: "莉",
    content: "莉",
    pronunciation: "lì",
    meaning: "人名用字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1876",
    type: "character",
    title: "悬",
    content: "悬",
    pronunciation: "xuán",
    meaning: "吊，挂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1877",
    type: "character",
    title: "唇",
    content: "唇",
    pronunciation: "chún",
    meaning: "嘴边缘呈红色的部分嘴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1878",
    type: "character",
    title: "翰",
    content: "翰",
    pronunciation: "hàn",
    meaning: "古书上指雉科的锦鸡或山鸡等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1879",
    type: "character",
    title: "仓",
    content: "仓",
    pronunciation: "cānɡ",
    meaning: "又如谷仓(粮仓);仓廒(粮库);仓敖(储藏米谷的地方)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1880",
    type: "character",
    title: "轨",
    content: "轨",
    pronunciation: "ɡuǐ",
    meaning: "车子两轮之间的距离车同",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1881",
    type: "character",
    title: "枚",
    content: "枚",
    pronunciation: "méi",
    meaning: "树干",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1882",
    type: "character",
    title: "盐",
    content: "盐",
    pronunciation: "yán",
    meaning: "盐，又叫\"咸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1883",
    type: "character",
    title: "览",
    content: "览",
    pronunciation: "lǎn",
    meaning: "又如览观(阅览);览读(阅读);览阅(阅览);览核(查阅);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1884",
    type: "character",
    title: "傅",
    content: "傅",
    pronunciation: "fù",
    meaning: "辅助，教导，也指教导传授技艺的人老师",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1885",
    type: "character",
    title: "帅",
    content: "帅",
    pronunciation: "shuài",
    meaning: "军队中最高级的指挥者元",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1886",
    type: "character",
    title: "庙",
    content: "庙",
    pronunciation: "miào",
    meaning: "供奉祖先、神佛或历史上有名人物的住所家",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1887",
    type: "character",
    title: "芬",
    content: "芬",
    pronunciation: "fēn",
    meaning: "香，香气",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1888",
    type: "character",
    title: "屏",
    content: "屏",
    pronunciation: "pínɡ",
    meaning: "遮挡，遮挡物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1889",
    type: "character",
    title: "寺",
    content: "寺",
    pronunciation: "sì",
    meaning: "〈古〉中央机构名或官署名大理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1890",
    type: "character",
    title: "胖",
    content: "胖",
    pronunciation: "pànɡ",
    meaning: "人体肥，体内含脂肪多，跟\"瘦\"相对体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1891",
    type: "character",
    title: "璃",
    content: "璃",
    pronunciation: "lí",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1892",
    type: "character",
    title: "愚",
    content: "愚",
    pronunciation: "yú",
    meaning: "笨，傻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1893",
    type: "character",
    title: "滴",
    content: "滴",
    pronunciation: "dī",
    meaning: "又如滴沥(水下滴);滴溜(涓滴的水);滴水(滴下来的水);滴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1894",
    type: "character",
    title: "疏",
    content: "疏",
    pronunciation: "shū",
    meaning: "去掉阻塞，使畅通",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1895",
    type: "character",
    title: "萧",
    content: "萧",
    pronunciation: "xiāo",
    meaning: "〈古〉称香蒿，也叫\"青蒿\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1896",
    type: "character",
    title: "姿",
    content: "姿",
    pronunciation: "zī",
    meaning: "容貌",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1897",
    type: "character",
    title: "颤",
    content: "颤",
    pronunciation: "chàn",
    meaning: "振动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1898",
    type: "character",
    title: "丑",
    content: "丑",
    pronunciation: "chǒu",
    meaning: "地支的第二位，也用作次序第二",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1899",
    type: "character",
    title: "劣",
    content: "劣",
    pronunciation: "liè",
    meaning: "恶，坏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1900",
    type: "character",
    title: "柯",
    content: "柯",
    pronunciation: "kē",
    meaning: "斧柄",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1901",
    type: "character",
    title: "寸",
    content: "寸",
    pronunciation: "cùn",
    meaning: "又如寸田(三丹田);寸关尺(中医指寸口、关上、尺中的简称)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1902",
    type: "character",
    title: "扔",
    content: "扔",
    pronunciation: "rēnɡ",
    meaning: "抛，掷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1903",
    type: "character",
    title: "盯",
    content: "盯",
    pronunciation: "dīnɡ",
    meaning: "紧跟着不放松",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1904",
    type: "character",
    title: "辱",
    content: "辱",
    pronunciation: "rǔ",
    meaning: "羞耻耻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1905",
    type: "character",
    title: "匹",
    content: "匹",
    pronunciation: "pǐ",
    meaning: "相当，相等，相配",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1906",
    type: "character",
    title: "俱",
    content: "俱",
    pronunciation: "jù",
    meaning: "全，都",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1907",
    type: "character",
    title: "辨",
    content: "辨",
    pronunciation: "biàn",
    meaning: "又如明辨是非;辨白(分辨清楚);辨色(辨别物色)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1908",
    type: "character",
    title: "饿",
    content: "饿",
    pronunciation: "è",
    meaning: "使受饿;感到饥饿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1909",
    type: "character",
    title: "蜂",
    content: "蜂",
    pronunciation: "fēnɡ",
    meaning: "昆虫",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1910",
    type: "character",
    title: "哦",
    content: "哦",
    pronunciation: "ò",
    meaning: "又如哦吟(吟咏,吟诗)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1911",
    type: "character",
    title: "腔",
    content: "腔",
    pronunciation: "qiānɡ",
    meaning: "动物体内中空的部分或藏有脏器的空隙鼻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1912",
    type: "character",
    title: "郁",
    content: "郁",
    pronunciation: "yù",
    meaning: "茂盛，树木丛生葱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1913",
    type: "character",
    title: "溃",
    content: "溃",
    pronunciation: "kuì",
    meaning: "水冲破堤坝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1914",
    type: "character",
    title: "谨",
    content: "谨",
    pronunciation: "jǐn",
    meaning: "慎重，小心",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1915",
    type: "character",
    title: "糟",
    content: "糟",
    pronunciation: "zāo",
    meaning: "酒渣",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1916",
    type: "character",
    title: "葛",
    content: "葛",
    pronunciation: "ɡě",
    meaning: "多年生草本，复叶，夏季开紫红色花",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1917",
    type: "character",
    title: "苗",
    content: "苗",
    pronunciation: "miáo",
    meaning: "没有吐穗的庄稼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1918",
    type: "character",
    title: "肠",
    content: "肠",
    pronunciation: "chánɡ",
    meaning: "内心,情怀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1919",
    type: "character",
    title: "忌",
    content: "忌",
    pronunciation: "jì",
    meaning: "嫉妒，憎恨妒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1920",
    type: "character",
    title: "溜",
    content: "溜",
    pronunciation: "liū",
    meaning: "滑行",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1921",
    type: "character",
    title: "鸿",
    content: "鸿",
    pronunciation: "hónɡ",
    meaning: "大型雁类的泛称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1922",
    type: "character",
    title: "爵",
    content: "爵",
    pronunciation: "jué",
    meaning: "〈古〉一种酒器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1923",
    type: "character",
    title: "鹏",
    content: "鹏",
    pronunciation: "pénɡ",
    meaning: "〈古〉传说中的一种大鸟",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1924",
    type: "character",
    title: "鹰",
    content: "鹰",
    pronunciation: "yīnɡ",
    meaning: "比喻爪牙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1925",
    type: "character",
    title: "笼",
    content: "笼",
    pronunciation: "lónɡ",
    meaning: "儱）lǒng",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1926",
    type: "character",
    title: "丘",
    content: "丘",
    pronunciation: "qiū",
    meaning: "土堆，小山土",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1927",
    type: "character",
    title: "桂",
    content: "桂",
    pronunciation: "ɡuì",
    meaning: "桂花树，常绿小乔木或灌木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1928",
    type: "character",
    title: "滋",
    content: "滋",
    pronunciation: "zī",
    meaning: "一名兹水,今名磁河。源出河北省阜平县西部南坨山东,今为潴龙河",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1929",
    type: "character",
    title: "聊",
    content: "聊",
    pronunciation: "liáo",
    meaning: "姑且，略微",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1930",
    type: "character",
    title: "挡",
    content: "挡",
    pronunciation: "dǎnɡ",
    meaning: "又如挡人牌(挡箭牌。在前边极力承担困难的人);挡手(商店经理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1931",
    type: "character",
    title: "纲",
    content: "纲",
    pronunciation: "ɡānɡ",
    meaning: "鱼网上的总绳网之",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1932",
    type: "character",
    title: "肌",
    content: "肌",
    pronunciation: "jī",
    meaning: "同本义(先秦时期,肌表示人的肉;肉表示禽兽的肉)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1933",
    type: "character",
    title: "茨",
    content: "茨",
    pronunciation: "cí",
    meaning: "用芦苇、茅草盖的屋顶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1934",
    type: "character",
    title: "壳",
    content: "壳",
    pronunciation: "ké",
    meaning: "坚硬的外皮螺蛳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1935",
    type: "character",
    title: "痕",
    content: "痕",
    pronunciation: "hén",
    meaning: "又如痕瑕(褊,斑点);痕挞(伤痕);痕瘕(疤痕。比喻曾犯过罪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1936",
    type: "character",
    title: "碗",
    content: "碗",
    pronunciation: "wǎn",
    meaning: "盛饮料、食品等的器皿茶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1937",
    type: "character",
    title: "穴",
    content: "穴",
    pronunciation: "xué",
    meaning: "岩洞，土室，窟窿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1938",
    type: "character",
    title: "膀",
    content: "膀",
    pronunciation: "bǎnɡ",
    meaning: "又如膀阔腰圆;腰细膀宽",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1939",
    type: "character",
    title: "卓",
    content: "卓",
    pronunciation: "zhuó",
    meaning: "高，高超，不平凡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1940",
    type: "character",
    title: "贤",
    content: "贤",
    pronunciation: "xián",
    meaning: "有道德、有才能的，也指德才兼备的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1941",
    type: "character",
    title: "卧",
    content: "卧",
    pronunciation: "wò",
    meaning: "伏在桌子上睡觉伏案而",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1942",
    type: "character",
    title: "膜",
    content: "膜",
    pronunciation: "mó",
    meaning: "动、植物体内像薄皮的组织耳鼓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1943",
    type: "character",
    title: "毅",
    content: "毅",
    pronunciation: "yì",
    meaning: "又如毅武(刚强勇武);毅烈(刚毅节烈)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1944",
    type: "character",
    title: "锦",
    content: "锦",
    pronunciation: "jǐn",
    meaning: "带有彩色花纹的丝织品蜀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1945",
    type: "character",
    title: "欠",
    content: "欠",
    pronunciation: "qiàn",
    meaning: "借而未还或当给未给",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1946",
    type: "character",
    title: "哩",
    content: "哩",
    pronunciation: "lǐ",
    meaning: "开会时间已到,但厅内哩哩啦啦才来了几个人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1947",
    type: "character",
    title: "函",
    content: "函",
    pronunciation: "hán",
    meaning: "匣，套钱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1948",
    type: "character",
    title: "茫",
    content: "茫",
    pronunciation: "mánɡ",
    meaning: "凝不清，全无所知渺",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1949",
    type: "character",
    title: "昂",
    content: "昂",
    pronunciation: "ánɡ",
    meaning: "仰，高抬",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1950",
    type: "character",
    title: "薛",
    content: "薛",
    pronunciation: "xuē",
    meaning: "一种草",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1951",
    type: "character",
    title: "皱",
    content: "皱",
    pronunciation: "zhòu",
    meaning: "皮肤上起的褶纹满脸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1952",
    type: "character",
    title: "夸",
    content: "夸",
    pronunciation: "kuā",
    meaning: "说大话",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1953",
    type: "character",
    title: "豫",
    content: "豫",
    pronunciation: "yù",
    meaning: "快乐，安乐不",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1954",
    type: "character",
    title: "胃",
    content: "胃",
    pronunciation: "wèi",
    meaning: "人和某些动物的消化器官之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1955",
    type: "character",
    title: "舌",
    content: "舌",
    pronunciation: "shé",
    meaning: "辨别滋味，帮助咀嚼和发音的器官，位于口腔底部",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1956",
    type: "character",
    title: "剥",
    content: "剥",
    pronunciation: "bāo",
    meaning: "又如剥花生;剥碗豆;剥牛皮;剥葱皮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1957",
    type: "character",
    title: "傲",
    content: "傲",
    pronunciation: "ào",
    meaning: "自高自大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1958",
    type: "character",
    title: "拾",
    content: "拾",
    pronunciation: "shí",
    meaning: "\"十\"的大写",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1959",
    type: "character",
    title: "窝",
    content: "窝",
    pronunciation: "wō",
    meaning: "鸟兽昆虫等的巢穴燕",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1960",
    type: "character",
    title: "睁",
    content: "睁",
    pronunciation: "zhēnɡ",
    meaning: "看,望;瞪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1961",
    type: "character",
    title: "携",
    content: "携",
    pronunciation: "xié",
    meaning: "提，拿，带",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1962",
    type: "character",
    title: "陵",
    content: "陵",
    pronunciation: "línɡ",
    meaning: "大土山丘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1963",
    type: "character",
    title: "哼",
    content: "哼",
    pronunciation: "hēnɡ",
    meaning: "鼻孔发出不舒服或痛苦的声音他",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1964",
    type: "character",
    title: "棉",
    content: "棉",
    pronunciation: "mián",
    meaning: "木棉,也叫攀枝花、英雄树",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1965",
    type: "character",
    title: "晴",
    content: "晴",
    pronunciation: "qínɡ",
    meaning: "又如晴岚(晴日山中的雾气);放晴(阴雨后转晴);晴川(晴天下",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1966",
    type: "character",
    title: "铃",
    content: "铃",
    pronunciation: "línɡ",
    meaning: "金属制成的响器，中有小锤，振动发音车",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1967",
    type: "character",
    title: "填",
    content: "填",
    pronunciation: "tián",
    meaning: "补塞，补装，补满空缺的地方",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1968",
    type: "character",
    title: "饲",
    content: "饲",
    pronunciation: "sì",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1969",
    type: "character",
    title: "渴",
    content: "渴",
    pronunciation: "kě",
    meaning: "又如好渴;当你渴的时候到罐子那里去喝水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1970",
    type: "character",
    title: "吻",
    content: "吻",
    pronunciation: "wěn",
    meaning: "嘴唇接",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1971",
    type: "character",
    title: "扮",
    content: "扮",
    pronunciation: "bàn",
    meaning: "打扮,装扮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1972",
    type: "character",
    title: "逆",
    content: "逆",
    pronunciation: "nì",
    meaning: "方向相反，跟\"顺\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1973",
    type: "character",
    title: "脆",
    content: "脆",
    pronunciation: "cuì",
    meaning: "鲜嫩爽口的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1974",
    type: "character",
    title: "喘",
    content: "喘",
    pronunciation: "chuǎn",
    meaning: "急促的呼吸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1975",
    type: "character",
    title: "罩",
    content: "罩",
    pronunciation: "zhào",
    meaning: "捕鱼用的竹笼，也指养鸡的笼子渔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1976",
    type: "character",
    title: "卜",
    content: "卜",
    pronunciation: "bo",
    meaning: "①占卜～卦。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1977",
    type: "character",
    title: "炉",
    content: "炉",
    pronunciation: "lú",
    meaning: "取暖、做饭、冶炼等用的供热器具手",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1978",
    type: "character",
    title: "柴",
    content: "柴",
    pronunciation: "chái",
    meaning: "木、草等燃料木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1979",
    type: "character",
    title: "愉",
    content: "愉",
    pronunciation: "yú",
    meaning: "又如愉怡(快乐和悦);愉心(愉悦心情);愉目(悦目);愉色(",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1980",
    type: "character",
    title: "绳",
    content: "绳",
    pronunciation: "shénɡ",
    meaning: "由两股或两股以上的棉、麻、棕、草、金属丝、化学纤维等拧成的条",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1981",
    type: "character",
    title: "胎",
    content: "胎",
    pronunciation: "tāi",
    meaning: "母体内的幼体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1982",
    type: "character",
    title: "蓄",
    content: "蓄",
    pronunciation: "xù",
    meaning: "积聚，储藏，保存",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1983",
    type: "character",
    title: "眠",
    content: "眠",
    pronunciation: "mián",
    meaning: "闭上眼睛微",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1984",
    type: "character",
    title: "竭",
    content: "竭",
    pronunciation: "jié",
    meaning: "尽，完",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1985",
    type: "character",
    title: "喂",
    content: "喂",
    pronunciation: "wèi",
    meaning: "将食物送进人的嘴里",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1986",
    type: "character",
    title: "傻",
    content: "傻",
    pronunciation: "shǎ",
    meaning: "笨，愚蠢太",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1987",
    type: "character",
    title: "慕",
    content: "慕",
    pronunciation: "mù",
    meaning: "想念思",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1988",
    type: "character",
    title: "浑",
    content: "浑",
    pronunciation: "hún",
    meaning: "污浊，水不清",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1989",
    type: "character",
    title: "奸",
    content: "奸",
    pronunciation: "jiān",
    meaning: "邪恶，狡诈",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1990",
    type: "character",
    title: "扇",
    content: "扇",
    pronunciation: "shàn",
    meaning: "摇动扇子或别的东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1991",
    type: "character",
    title: "柜",
    content: "柜",
    pronunciation: "ɡuì",
    meaning: "柜柳，落叶乔木，羽状复叶，树性耐湿、耐碱，可固沙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1992",
    type: "character",
    title: "悦",
    content: "悦",
    pronunciation: "yuè",
    meaning: "高兴，愉快喜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1993",
    type: "character",
    title: "拦",
    content: "拦",
    pronunciation: "lán",
    meaning: "【拦挡】不使通过；使中途停止。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1994",
    type: "character",
    title: "诞",
    content: "诞",
    pronunciation: "dàn",
    meaning: "又如诞诈(诞妄奸诈);诞辞(虚诞的言辞);诞言(夸大的话)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1995",
    type: "character",
    title: "饱",
    content: "饱",
    pronunciation: "bǎo",
    meaning: "同本义。与饥相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1996",
    type: "character",
    title: "乾",
    content: "乾",
    pronunciation: "qián",
    meaning: "八卦之一，代表天",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1997",
    type: "character",
    title: "泡",
    content: "泡",
    pronunciation: "pào",
    meaning: "鼓起且松软的东西豆腐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1998",
    type: "character",
    title: "贼",
    content: "贼",
    pronunciation: "zéi",
    meaning: "匪盗，偷东西的人盗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-1999",
    type: "character",
    title: "亭",
    content: "亭",
    pronunciation: "tínɡ",
    meaning: "亭子，一般是圆顶或多角形无墙的建筑物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2000",
    type: "character",
    title: "夕",
    content: "夕",
    pronunciation: "xī",
    meaning: "傍晚，日落的时候朝不保",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2001",
    type: "character",
    title: "爹",
    content: "爹",
    pronunciation: "diē",
    meaning: "对老者、长者的尊称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2002",
    type: "character",
    title: "酬",
    content: "酬",
    pronunciation: "chóu",
    meaning: "敬酒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2003",
    type: "character",
    title: "儒",
    content: "儒",
    pronunciation: "rú",
    meaning: "旧时指读书人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2004",
    type: "character",
    title: "姻",
    content: "姻",
    pronunciation: "yīn",
    meaning: "〈古〉指女婿的父亲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2005",
    type: "character",
    title: "卵",
    content: "卵",
    pronunciation: "luǎn",
    meaning: "生物的雌性生殖细胞",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2006",
    type: "character",
    title: "氛",
    content: "氛",
    pronunciation: "fēn",
    meaning: "泛指雾气;云气",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2007",
    type: "character",
    title: "泄",
    content: "泄",
    pronunciation: "xiè",
    meaning: "排出，流出排",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2008",
    type: "character",
    title: "杆",
    content: "杆",
    pronunciation: "ɡǎn",
    meaning: "细长的条状物秤",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2009",
    type: "character",
    title: "挨",
    content: "挨",
    pronunciation: "āi",
    meaning: "依次，顺次",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2010",
    type: "character",
    title: "僧",
    content: "僧",
    pronunciation: "sēnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2011",
    type: "character",
    title: "蜜",
    content: "蜜",
    pronunciation: "mì",
    meaning: "蜂蜜，蜜蜂采取花的甜汁酿成的东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2012",
    type: "character",
    title: "吟",
    content: "吟",
    pronunciation: "yín",
    meaning: "声调抑扬地念颂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2013",
    type: "character",
    title: "猩",
    content: "猩",
    pronunciation: "xīnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2014",
    type: "character",
    title: "遂",
    content: "遂",
    pronunciation: "suí",
    meaning: "顺，如意",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2015",
    type: "character",
    title: "狭",
    content: "狭",
    pronunciation: "xiá",
    meaning: "又如狭缝;狭路相逢;狭长(窄而长);狭迫(窄小局促)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2016",
    type: "character",
    title: "肖",
    content: "肖",
    pronunciation: "xiāo",
    meaning: "相似，类似惟妙惟",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2017",
    type: "character",
    title: "甜",
    content: "甜",
    pronunciation: "tián",
    meaning: "萰tián",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2018",
    type: "character",
    title: "霞",
    content: "霞",
    pronunciation: "xiá",
    meaning: "失向来之烟霞。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2019",
    type: "character",
    title: "驳",
    content: "驳",
    pronunciation: "bó",
    meaning: "又如驳骏(毛色斑驳的骏马);乌驳马。又泛指颜色不纯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2020",
    type: "character",
    title: "裕",
    content: "裕",
    pronunciation: "yù",
    meaning: "丰富，宽绰富",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2021",
    type: "character",
    title: "顽",
    content: "顽",
    pronunciation: "wán",
    meaning: "愚蠢无知愚",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2022",
    type: "character",
    title: "摘",
    content: "摘",
    pronunciation: "zhāi",
    meaning: "采取，取下",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2023",
    type: "character",
    title: "矮",
    content: "矮",
    pronunciation: "ǎi",
    meaning: "不高",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2024",
    type: "character",
    title: "秒",
    content: "秒",
    pronunciation: "miǎo",
    meaning: "谷物种子壳上的芒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2025",
    type: "character",
    title: "卿",
    content: "卿",
    pronunciation: "qīnɡ",
    meaning: "〈古〉高级官名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2026",
    type: "character",
    title: "畜",
    content: "畜",
    pronunciation: "chù",
    meaning: "禽兽，一般指家养的幼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2027",
    type: "character",
    title: "咽",
    content: "咽",
    pronunciation: "yān",
    meaning: "声音哽塞呜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2028",
    type: "character",
    title: "披",
    content: "披",
    pronunciation: "pī",
    meaning: "穿，覆盖在肩背上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2029",
    type: "character",
    title: "辅",
    content: "辅",
    pronunciation: "fǔ",
    meaning: "车轮外的两个直条，用以增强车辐的承载力",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2030",
    type: "character",
    title: "勾",
    content: "勾",
    pronunciation: "ɡōu",
    meaning: "用笔打勾，删除或截取一笔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2031",
    type: "character",
    title: "盆",
    content: "盆",
    pronunciation: "pén",
    meaning: "赌博的门道)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2032",
    type: "character",
    title: "疆",
    content: "疆",
    pronunciation: "jiānɡ",
    meaning: "界限，边界，边境守卫",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2033",
    type: "character",
    title: "赌",
    content: "赌",
    pronunciation: "dǔ",
    meaning: "钱(以金钱为输赢的赌博);赌运(赌博的运气);赌贩(赌棍);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2034",
    type: "character",
    title: "塑",
    content: "塑",
    pronunciation: "sù",
    meaning: "用泥土、石膏等做成的人物形象",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2035",
    type: "character",
    title: "畏",
    content: "畏",
    pronunciation: "wèi",
    meaning: "怕，恐惧",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2036",
    type: "character",
    title: "吵",
    content: "吵",
    pronunciation: "chǎo",
    meaning: "口角，斗嘴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2037",
    type: "character",
    title: "囊",
    content: "囊",
    pronunciation: "nánɡ",
    meaning: "口袋，盛物的袋子麻布",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2038",
    type: "character",
    title: "嗯",
    content: "嗯",
    pronunciation: "en1/ng/en4",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2039",
    type: "character",
    title: "泊",
    content: "泊",
    pronunciation: "bó",
    meaning: "湖，地名湖",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2040",
    type: "character",
    title: "肺",
    content: "肺",
    pronunciation: "fèi",
    meaning: "人和高等动物的呼吸器官之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2041",
    type: "character",
    title: "骤",
    content: "骤",
    pronunciation: "zhòu",
    meaning: "马奔驰弛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2042",
    type: "character",
    title: "缠",
    content: "缠",
    pronunciation: "chán",
    meaning: "盘绕，扎束",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2043",
    type: "character",
    title: "冈",
    content: "冈",
    pronunciation: "ɡānɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2044",
    type: "character",
    title: "羞",
    content: "羞",
    pronunciation: "xiū",
    meaning: "害臊，难为情，使难为情",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2045",
    type: "character",
    title: "瞪",
    content: "瞪",
    pronunciation: "dènɡ",
    meaning: "睁大眼睛直视",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2046",
    type: "character",
    title: "吊",
    content: "吊",
    pronunciation: "diào",
    meaning: "引申为慰问",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2047",
    type: "character",
    title: "贾",
    content: "贾",
    pronunciation: "jiǎ",
    meaning: "〈古〉商人富商大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2048",
    type: "character",
    title: "漏",
    content: "漏",
    pronunciation: "lòu",
    meaning: "物体从孔隙透过或滴下",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2049",
    type: "character",
    title: "斑",
    content: "斑",
    pronunciation: "bān",
    meaning: "又如汗斑;斑马;斑污(斑点污渍);雀斑;豹子的斑;油斑",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2050",
    type: "character",
    title: "涛",
    content: "涛",
    pronunciation: "tāo",
    meaning: "大波浪波",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2051",
    type: "character",
    title: "悠",
    content: "悠",
    pronunciation: "yōu",
    meaning: "长远，长久",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2052",
    type: "character",
    title: "鹿",
    content: "鹿",
    pronunciation: "lù",
    meaning: "又如鹿中(刻成鹿形的木器);鹿伏鹤行(形容小心警惕的样子)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2053",
    type: "character",
    title: "俘",
    content: "俘",
    pronunciation: "fú",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2054",
    type: "character",
    title: "锡",
    content: "锡",
    pronunciation: "xī",
    meaning: "金属化学元素之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2055",
    type: "character",
    title: "卑",
    content: "卑",
    pronunciation: "bēi",
    meaning: "地位低微",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2056",
    type: "character",
    title: "葬",
    content: "葬",
    pronunciation: "zànɡ",
    meaning: "掩埋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2057",
    type: "character",
    title: "铭",
    content: "铭",
    pronunciation: "mínɡ",
    meaning: "刻写在器物上记述生平、事业或警语等的文字鼎",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2058",
    type: "character",
    title: "滩",
    content: "滩",
    pronunciation: "tān",
    meaning: "江、河或海边泥沙淤积的平地",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2059",
    type: "character",
    title: "嫁",
    content: "嫁",
    pronunciation: "jià",
    meaning: "女子结婚她今天出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2060",
    type: "character",
    title: "催",
    content: "催",
    pronunciation: "cuī",
    meaning: "①叫人赶紧做某事家里来信，～你回去呢。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2061",
    type: "character",
    title: "璇",
    content: "璇",
    pronunciation: "xuán",
    meaning: "美玉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2062",
    type: "character",
    title: "翅",
    content: "翅",
    pronunciation: "chì",
    meaning: "鸟类、昆虫等用于飞行的器官",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2063",
    type: "character",
    title: "盒",
    content: "盒",
    pronunciation: "hé",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2064",
    type: "character",
    title: "蛮",
    content: "蛮",
    pronunciation: "mán",
    meaning: "粗野，强横野",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2065",
    type: "character",
    title: "矣",
    content: "矣",
    pronunciation: "yǐ",
    meaning: "直陈语气，相当于\"了\"由来久",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2066",
    type: "character",
    title: "潘",
    content: "潘",
    pronunciation: "pān",
    meaning: "在河南省荥阳县境",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2067",
    type: "character",
    title: "歧",
    content: "歧",
    pronunciation: "qí",
    meaning: "岔道，大路分出的小路",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2068",
    type: "character",
    title: "赐",
    content: "赐",
    pronunciation: "cì",
    meaning: "给予;上给予下",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2069",
    type: "character",
    title: "鲍",
    content: "鲍",
    pronunciation: "bào",
    meaning: "盐腌的鱼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2070",
    type: "character",
    title: "锅",
    content: "锅",
    pronunciation: "ɡuō",
    meaning: "煮炒食物等的器具炒菜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2071",
    type: "character",
    title: "廊",
    content: "廊",
    pronunciation: "lánɡ",
    meaning: "有覆盖顶的过道长",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2072",
    type: "character",
    title: "拆",
    content: "拆",
    pronunciation: "chāi",
    meaning: "弄开，分开，卸下来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2073",
    type: "character",
    title: "灌",
    content: "灌",
    pronunciation: "ɡuàn",
    meaning: "浇，输送",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2074",
    type: "character",
    title: "勉",
    content: "勉",
    pronunciation: "miǎn",
    meaning: "尽力，努力勤",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2075",
    type: "character",
    title: "盲",
    content: "盲",
    pronunciation: "mánɡ",
    meaning: "瞎，看不见物体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2076",
    type: "character",
    title: "宰",
    content: "宰",
    pronunciation: "zǎi",
    meaning: "杀牲畜，割肉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2077",
    type: "character",
    title: "佐",
    content: "佐",
    pronunciation: "zuǒ",
    meaning: "又如佐理(助理,帮助处理);佐事(辅助事奉);佐戎(参与军事",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2078",
    type: "character",
    title: "啥",
    content: "啥",
    pronunciation: "shá",
    meaning: ");干啥",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2079",
    type: "character",
    title: "胀",
    content: "胀",
    pronunciation: "zhànɡ",
    meaning: "体积变大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2080",
    type: "character",
    title: "扯",
    content: "扯",
    pronunciation: "chě",
    meaning: "拉,牵引",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2081",
    type: "character",
    title: "禧",
    content: "禧",
    pronunciation: "xǐ",
    meaning: "幸福，吉祥",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2082",
    type: "character",
    title: "辽",
    content: "辽",
    pronunciation: "liáo",
    meaning: "又如辽绝(远隔);辽险(遥远险要);辽天(远天);辽阻(辽远",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2083",
    type: "character",
    title: "抹",
    content: "抹",
    pronunciation: "mò",
    meaning: "又如抹脱(擦掉);抹泪揉眵(揩拭眼泪);抹抹(揩抹干净)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2084",
    type: "character",
    title: "筒",
    content: "筒",
    pronunciation: "tǒnɡ",
    meaning: "粗大的竹管",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2085",
    type: "character",
    title: "棋",
    content: "棋",
    pronunciation: "qí",
    meaning: "又如棋枰(棋盘);棋子(一种干粮);象棋;国际象棋;围棋;跳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2086",
    type: "character",
    title: "裤",
    content: "裤",
    pronunciation: "kù",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2087",
    type: "character",
    title: "唉",
    content: "唉",
    pronunciation: "āi",
    meaning: "又如你一定要去呀!唉,我是要去的。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2088",
    type: "character",
    title: "朴",
    content: "朴",
    pronunciation: "pǔ",
    meaning: "树木的皮,木皮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2089",
    type: "character",
    title: "咐",
    content: "咐",
    pronunciation: "fù",
    meaning: "吩咐嘱托;安排",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2090",
    type: "character",
    title: "孕",
    content: "孕",
    pronunciation: "yùn",
    meaning: "胎，怀胎怀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2091",
    type: "character",
    title: "誓",
    content: "誓",
    pronunciation: "shì",
    meaning: "〈表〉坚定不移的决心",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2092",
    type: "character",
    title: "喉",
    content: "喉",
    pronunciation: "hóu",
    meaning: "也叫\"喉头\"◆吸器官之一，气管上方由软骨和肌肉等构成的部分，",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2093",
    type: "character",
    title: "妄",
    content: "妄",
    pronunciation: "wànɡ",
    meaning: "虚妄,极不真实",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2094",
    type: "character",
    title: "拘",
    content: "拘",
    pronunciation: "jū",
    meaning: "扣押或逮捕",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2095",
    type: "character",
    title: "链",
    content: "链",
    pronunciation: "liàn",
    meaning: "用金属环连套构成的长条铁",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2096",
    type: "character",
    title: "驰",
    content: "驰",
    pronunciation: "chí",
    meaning: "奔跑，使劲赶马",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2097",
    type: "character",
    title: "栏",
    content: "栏",
    pronunciation: "lán",
    meaning: "遮挡的东西竹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2098",
    type: "character",
    title: "逝",
    content: "逝",
    pronunciation: "shì",
    meaning: "去，离去时光易",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2099",
    type: "character",
    title: "窃",
    content: "窃",
    pronunciation: "qiè",
    meaning: "偷，用不合法、不正当的手段取得偷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2100",
    type: "character",
    title: "艳",
    content: "艳",
    pronunciation: "yàn",
    meaning: "长得漂亮美而",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2101",
    type: "character",
    title: "臭",
    content: "臭",
    pronunciation: "chòu",
    meaning: "难闻的气味，跟\"香\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2102",
    type: "character",
    title: "纤",
    content: "纤",
    pronunciation: "xiān",
    meaning: "拉船的绳子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2103",
    type: "character",
    title: "玑",
    content: "玑",
    pronunciation: "jī",
    meaning: "不圆的珠子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2104",
    type: "character",
    title: "棵",
    content: "棵",
    pronunciation: "kē",
    meaning: "量词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2105",
    type: "character",
    title: "趁",
    content: "趁",
    pronunciation: "chèn",
    meaning: "顺便，乘机会",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2106",
    type: "character",
    title: "匠",
    content: "匠",
    pronunciation: "jiànɡ",
    meaning: "泛指有专门手艺的工人木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2107",
    type: "character",
    title: "盈",
    content: "盈",
    pronunciation: "yínɡ",
    meaning: "充满，圆满充",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2108",
    type: "character",
    title: "翁",
    content: "翁",
    pronunciation: "wēnɡ",
    meaning: "父亲我",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2109",
    type: "character",
    title: "愁",
    content: "愁",
    pronunciation: "chóu",
    meaning: "忧虑忧",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2110",
    type: "character",
    title: "瞬",
    content: "瞬",
    pronunciation: "shùn",
    meaning: "又如一瞬(一眨眼工夫)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2111",
    type: "character",
    title: "婴",
    content: "婴",
    pronunciation: "yīnɡ",
    meaning: "初生的小孩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2112",
    type: "character",
    title: "孝",
    content: "孝",
    pronunciation: "xiào",
    meaning: "旧指尽心奉养和绝对服从父母",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2113",
    type: "character",
    title: "颈",
    content: "颈",
    pronunciation: "jǐnɡ",
    meaning: "俗称\"脖子\"，头与躯干相连的部分引",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2114",
    type: "character",
    title: "倘",
    content: "倘",
    pronunciation: "tǎnɡ",
    meaning: "如果，假使",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2115",
    type: "character",
    title: "浙",
    content: "浙",
    pronunciation: "zhè",
    meaning: "古州名,浙州",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2116",
    type: "character",
    title: "谅",
    content: "谅",
    pronunciation: "liànɡ",
    meaning: "原谅，体谅见",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2117",
    type: "character",
    title: "蔽",
    content: "蔽",
    pronunciation: "bì",
    meaning: "遮住,遮掩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2118",
    type: "character",
    title: "畅",
    content: "畅",
    pronunciation: "chànɡ",
    meaning: "无阻碍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2119",
    type: "character",
    title: "赠",
    content: "赠",
    pronunciation: "zènɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2120",
    type: "character",
    title: "妮",
    content: "妮",
    pronunciation: "nī",
    meaning: "女孩子小",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2121",
    type: "character",
    title: "莎",
    content: "莎",
    pronunciation: "shā",
    meaning: "⒈多见于人名、地名。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2122",
    type: "character",
    title: "尉",
    content: "尉",
    pronunciation: "wèi",
    meaning: "军衔名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2123",
    type: "character",
    title: "冻",
    content: "冻",
    pronunciation: "dònɡ",
    meaning: "又如冻柱(冻住);冻浦(结了冰的河川)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2124",
    type: "character",
    title: "跪",
    content: "跪",
    pronunciation: "ɡuì",
    meaning: "又如授立不跪;长跪,半跪;跪拜;跪射;跪下祈祷;跪香拜佛(为",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2125",
    type: "character",
    title: "闯",
    content: "闯",
    pronunciation: "chuǎnɡ",
    meaning: "猛冲，敢干",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2126",
    type: "character",
    title: "葡",
    content: "葡",
    pronunciation: "pú",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2127",
    type: "character",
    title: "厨",
    content: "厨",
    pronunciation: "chú",
    meaning: "又如厨下(厨房);厨头(厨房);厨仓(厨房与粮仓);厨帐(账",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2128",
    type: "character",
    title: "鸭",
    content: "鸭",
    pronunciation: "yā",
    meaning: "水禽名。俗称鸭子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2129",
    type: "character",
    title: "颠",
    content: "颠",
    pronunciation: "diān",
    meaning: "又如颠毛(头发);颠顶(头顶);颠童(形容老人头发稀少)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2130",
    type: "character",
    title: "遮",
    content: "遮",
    pronunciation: "zhē",
    meaning: "拦住，阻断",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2131",
    type: "character",
    title: "谊",
    content: "谊",
    pronunciation: "yì",
    meaning: "又如谊士(义士);谊主(指明礼义的国君)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2132",
    type: "character",
    title: "圳",
    content: "圳",
    pronunciation: "zhèn",
    meaning: "田边水沟（多用于地名）深～；～口（均在中国广东省）。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2133",
    type: "character",
    title: "吁",
    content: "吁",
    pronunciation: "yù",
    meaning: "为某种要求而呼喊，多用于书面文章呼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2134",
    type: "character",
    title: "仑",
    content: "仑",
    pronunciation: "lún",
    meaning: "崙）lún",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2135",
    type: "character",
    title: "辟",
    content: "辟",
    pronunciation: "pì",
    meaning: "开，打开，开发开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2136",
    type: "character",
    title: "瘤",
    content: "瘤",
    pronunciation: "liú",
    meaning: "又如瘤牛;瘤赘(体表或筋骨间增生的肉疙瘩)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2137",
    type: "character",
    title: "嫂",
    content: "嫂",
    pronunciation: "sǎo",
    meaning: "哥哥的妻子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2138",
    type: "character",
    title: "陀",
    content: "陀",
    pronunciation: "tuó",
    meaning: "山冈",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2139",
    type: "character",
    title: "框",
    content: "框",
    pronunciation: "kuànɡ",
    meaning: "门、窗的边架门",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2140",
    type: "character",
    title: "谭",
    content: "谭",
    pronunciation: "tán",
    meaning: "同\"谈\"老生常",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2141",
    type: "character",
    title: "亨",
    content: "亨",
    pronunciation: "hēnɡ",
    meaning: "通达，顺利",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2142",
    type: "character",
    title: "钦",
    content: "钦",
    pronunciation: "qīn",
    meaning: "恭敬，敬重",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2143",
    type: "character",
    title: "庸",
    content: "庸",
    pronunciation: "yōnɡ",
    meaning: "常，平常的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2144",
    type: "character",
    title: "歉",
    content: "歉",
    pronunciation: "qiàn",
    meaning: "觉得对不起人抱",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2145",
    type: "character",
    title: "芝",
    content: "芝",
    pronunciation: "zhī",
    meaning: "⒉〈古〉指白芷。一种香草～兰。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2146",
    type: "character",
    title: "吼",
    content: "吼",
    pronunciation: "hǒu",
    meaning: "兽大声叫狮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2147",
    type: "character",
    title: "甫",
    content: "甫",
    pronunciation: "fǔ",
    meaning: "才，刚刚年",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2148",
    type: "character",
    title: "衫",
    content: "衫",
    pronunciation: "shān",
    meaning: "古代指无袖头的开衩上衣",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2149",
    type: "character",
    title: "摊",
    content: "摊",
    pronunciation: "tān",
    meaning: "展开，摆开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2150",
    type: "character",
    title: "宴",
    content: "宴",
    pronunciation: "yàn",
    meaning: "用酒饭招待客人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2151",
    type: "character",
    title: "嘱",
    content: "嘱",
    pronunciation: "zhǔ",
    meaning: "又如嘱板(嘱其牵扳)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2152",
    type: "character",
    title: "衷",
    content: "衷",
    pronunciation: "zhōnɡ",
    meaning: "贴身的内衣",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2153",
    type: "character",
    title: "娇",
    content: "娇",
    pronunciation: "jiāo",
    meaning: "美好可爱万紫千红分外",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2154",
    type: "character",
    title: "陕",
    content: "陕",
    pronunciation: "shǎn",
    meaning: "古地名。战国陕邑,在今河南省陕县",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2155",
    type: "character",
    title: "矩",
    content: "矩",
    pronunciation: "jǔ",
    meaning: "力和力臂的乘积",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2156",
    type: "character",
    title: "浦",
    content: "浦",
    pronunciation: "pǔ",
    meaning: "指池、塘、江河等水面",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2157",
    type: "character",
    title: "讶",
    content: "讶",
    pronunciation: "yà",
    meaning: "又如讶客(迎接宾客);讶宾(迎宾)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2158",
    type: "character",
    title: "耸",
    content: "耸",
    pronunciation: "sǒnɡ",
    meaning: "高起，直立高",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2159",
    type: "character",
    title: "裸",
    content: "裸",
    pronunciation: "luǒ",
    meaning: "光着身体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2160",
    type: "character",
    title: "碧",
    content: "碧",
    pronunciation: "bì",
    meaning: "章峨之山多瑶碧。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2161",
    type: "character",
    title: "摧",
    content: "摧",
    pronunciation: "cuī",
    meaning: "又如摧折(折断毁坏);摧剥(摧折剥落);摧烧(折断而投于火中",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2162",
    type: "character",
    title: "薪",
    content: "薪",
    pronunciation: "xīn",
    meaning: "柴草，柴火釜底抽",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2163",
    type: "character",
    title: "淋",
    content: "淋",
    pronunciation: "lín",
    meaning: "过滤过",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2164",
    type: "character",
    title: "耻",
    content: "耻",
    pronunciation: "chǐ",
    meaning: "同本义(因声誉受损害而至的内心羞愧)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2165",
    type: "character",
    title: "胶",
    content: "胶",
    pronunciation: "jiāo",
    meaning: "粘性物质",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2166",
    type: "character",
    title: "屠",
    content: "屠",
    pronunciation: "tú",
    meaning: "宰杀牲畜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2167",
    type: "character",
    title: "鹅",
    content: "鹅",
    pronunciation: "é",
    meaning: "同本义。鸭科中一明确亚科的鸟",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2168",
    type: "character",
    title: "饥",
    content: "饥",
    pronunciation: "jī",
    meaning: "饿，跟\"饱\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2169",
    type: "character",
    title: "盼",
    content: "盼",
    pronunciation: "pàn",
    meaning: "看顾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2170",
    type: "character",
    title: "脖",
    content: "脖",
    pronunciation: "bó",
    meaning: "①头和躯干相连接的部分。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2171",
    type: "character",
    title: "虹",
    content: "虹",
    pronunciation: "hónɡ",
    meaning: "大气中的小水珠经日光照射发生折射和反射所形成的圆弧形彩带，中",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2172",
    type: "character",
    title: "翠",
    content: "翠",
    pronunciation: "cuì",
    meaning: "鸟名,翠鸟。又专指雌性的翠鸟",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2173",
    type: "character",
    title: "崩",
    content: "崩",
    pronunciation: "bēnɡ",
    meaning: "又如山崩地裂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2174",
    type: "character",
    title: "账",
    content: "账",
    pronunciation: "zhànɡ",
    meaning: "钱财出入的记载记",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2175",
    type: "character",
    title: "萍",
    content: "萍",
    pronunciation: "pínɡ",
    meaning: "［浮萍］也叫\"水萍\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2176",
    type: "character",
    title: "逢",
    content: "逢",
    pronunciation: "fénɡ",
    meaning: "遭遇",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2177",
    type: "character",
    title: "赚",
    content: "赚",
    pronunciation: "zuàn",
    meaning: "诳骗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2178",
    type: "character",
    title: "撑",
    content: "撑",
    pronunciation: "chēnɡ",
    meaning: "抵住",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2179",
    type: "character",
    title: "翔",
    content: "翔",
    pronunciation: "xiánɡ",
    meaning: "张开翅膀盘旋地飞飞",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2180",
    type: "character",
    title: "倡",
    content: "倡",
    pronunciation: "chànɡ",
    meaning: "又如倡家(歌楼酒馆。也 指妓院)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2181",
    type: "character",
    title: "绵",
    content: "绵",
    pronunciation: "mián",
    meaning: "蚕丝结成的片或团丝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2182",
    type: "character",
    title: "猴",
    content: "猴",
    pronunciation: "hóu",
    meaning: "比喻机灵的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2183",
    type: "character",
    title: "枯",
    content: "枯",
    pronunciation: "kū",
    meaning: "草木干萎",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2184",
    type: "character",
    title: "巫",
    content: "巫",
    pronunciation: "wū",
    meaning: "商代的巫地位较高。周时分男巫、女巫,司职各异,同属司巫。春秋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2185",
    type: "character",
    title: "昭",
    content: "昭",
    pronunciation: "zhāo",
    meaning: "明白，显著",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2186",
    type: "character",
    title: "怔",
    content: "怔",
    pronunciation: "zhēnɡ",
    meaning: "因吃惊而呆住的样子发",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2187",
    type: "character",
    title: "渊",
    content: "渊",
    pronunciation: "yuān",
    meaning: "深水，潭深",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2188",
    type: "character",
    title: "凑",
    content: "凑",
    pronunciation: "còu",
    meaning: "又如凑队(集合在一起);凑聚(集合,聚集);凑泊(凝聚,结合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2189",
    type: "character",
    title: "溪",
    content: "溪",
    pronunciation: "xī",
    meaning: "山间不与外界相通的小河沟",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2190",
    type: "character",
    title: "蠢",
    content: "蠢",
    pronunciation: "chǔn",
    meaning: "虫类爬动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2191",
    type: "character",
    title: "禅",
    content: "禅",
    pronunciation: "chán",
    meaning: "梵文\"禅那\"的简称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2192",
    type: "character",
    title: "阐",
    content: "阐",
    pronunciation: "chǎn",
    meaning: "说明，表明",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2193",
    type: "character",
    title: "旺",
    content: "旺",
    pronunciation: "wànɡ",
    meaning: "火势炽烈",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2194",
    type: "character",
    title: "寓",
    content: "寓",
    pronunciation: "yù",
    meaning: "居住，寄居",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2195",
    type: "character",
    title: "藤",
    content: "藤",
    pronunciation: "ténɡ",
    meaning: "植物名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2196",
    type: "character",
    title: "匪",
    content: "匪",
    pronunciation: "fěi",
    meaning: "盗贼，抢劫财物的坏人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2197",
    type: "character",
    title: "伞",
    content: "伞",
    pronunciation: "sǎn",
    meaning: "挡雨或遮阳光的用具，可张可收雨",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2198",
    type: "character",
    title: "碑",
    content: "碑",
    pronunciation: "bēi",
    meaning: "石碑。石上刻着文字,作为纪念物或标记,也用以刻文告。秦代称刻",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2199",
    type: "character",
    title: "挪",
    content: "挪",
    pronunciation: "nuó",
    meaning: "移动,从一处移到另一处",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2200",
    type: "character",
    title: "琼",
    content: "琼",
    pronunciation: "qiónɡ",
    meaning: "美玉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2201",
    type: "character",
    title: "脂",
    content: "脂",
    pronunciation: "zhī",
    meaning: "动植物中所含的油质",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2202",
    type: "character",
    title: "谎",
    content: "谎",
    pronunciation: "huǎnɡ",
    meaning: "骗人，假话",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2203",
    type: "character",
    title: "慨",
    content: "慨",
    pronunciation: "kǎi",
    meaning: "嘅）kǎi",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2204",
    type: "character",
    title: "菩",
    content: "菩",
    pronunciation: "pú",
    meaning: "又指觉悟的智慧和觉悟的途径;亦指树名,即菩提树",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2205",
    type: "character",
    title: "萄",
    content: "萄",
    pronunciation: "táo",
    meaning: "如葡萄",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2206",
    type: "character",
    title: "狮",
    content: "狮",
    pronunciation: "shī",
    meaning: "犬生二子称狮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2207",
    type: "character",
    title: "掘",
    content: "掘",
    pronunciation: "jué",
    meaning: "通屈。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2208",
    type: "character",
    title: "抄",
    content: "抄",
    pronunciation: "chāo",
    meaning: "誊写",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2209",
    type: "character",
    title: "岭",
    content: "岭",
    pronunciation: "lǐnɡ",
    meaning: "顶上有路可通行的山,亦泛指山峰",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2210",
    type: "character",
    title: "晕",
    content: "晕",
    pronunciation: "yūn",
    meaning: "昏迷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2211",
    type: "character",
    title: "逮",
    content: "逮",
    pronunciation: "dǎi",
    meaning: "又如逮及(达到,到了",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2212",
    type: "character",
    title: "砍",
    content: "砍",
    pronunciation: "kǎn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2213",
    type: "character",
    title: "掏",
    content: "掏",
    pronunciation: "tāo",
    meaning: "同搯。挖取",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2214",
    type: "character",
    title: "狄",
    content: "狄",
    pronunciation: "dí",
    meaning: "是中国中原人对北方各民族的泛称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2215",
    type: "character",
    title: "晰",
    content: "晰",
    pronunciation: "xī",
    meaning: "又如晰晰(光亮的样子)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2216",
    type: "character",
    title: "罕",
    content: "罕",
    pronunciation: "hǎn",
    meaning: "又如罕车(载有猎狩等网具的车;星宿名,毕宿的别名。因毕八星排",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2217",
    type: "character",
    title: "挽",
    content: "挽",
    pronunciation: "wǎn",
    meaning: "设法扭转局势使变好或复原",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2218",
    type: "character",
    title: "脾",
    content: "脾",
    pronunciation: "pí",
    meaning: "脾脏，人和动物内脏之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2219",
    type: "character",
    title: "舟",
    content: "舟",
    pronunciation: "zhōu",
    meaning: "两岸猿声啼不住,轻舟已",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2220",
    type: "character",
    title: "痴",
    content: "痴",
    pronunciation: "chī",
    meaning: "又如痴哑(痴呆喑哑);痴呆呆(傻乎乎)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2221",
    type: "character",
    title: "蔡",
    content: "蔡",
    pronunciation: "cài",
    meaning: "周代国名,在今河南省上蔡、新蔡等县一带",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2222",
    type: "character",
    title: "剪",
    content: "剪",
    pronunciation: "jiǎn",
    meaning: "同本义。本作前,通作翦,俗作剪",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2223",
    type: "character",
    title: "脊",
    content: "脊",
    pronunciation: "jǐ",
    meaning: "人或动物背部的中轴骨骼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2224",
    type: "character",
    title: "弓",
    content: "弓",
    pronunciation: "ɡōnɡ",
    meaning: "弯曲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2225",
    type: "character",
    title: "懒",
    content: "懒",
    pronunciation: "lǎn",
    meaning: "怠惰，不肯用劲做",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2226",
    type: "character",
    title: "叉",
    content: "叉",
    pronunciation: "chā",
    meaning: "相交，交错",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2227",
    type: "character",
    title: "拐",
    content: "拐",
    pronunciation: "ɡuǎi",
    meaning: "转弯，转折",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2228",
    type: "character",
    title: "喃",
    content: "喃",
    pronunciation: "nán",
    meaning: "语气词,相当于呢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2229",
    type: "character",
    title: "僚",
    content: "僚",
    pronunciation: "liáo",
    meaning: "官，官吏官",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2230",
    type: "character",
    title: "捐",
    content: "捐",
    pronunciation: "juān",
    meaning: "捐助，献出财物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2231",
    type: "character",
    title: "姊",
    content: "姊",
    pronunciation: "zǐ",
    meaning: "姐姐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2232",
    type: "character",
    title: "骚",
    content: "骚",
    pronunciation: "sāo",
    meaning: "动乱，扰乱，不安定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2233",
    type: "character",
    title: "拓",
    content: "拓",
    pronunciation: "tuò",
    meaning: "将碑刻、古器物等上面的文字、图像，摹印在纸上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2234",
    type: "character",
    title: "歪",
    content: "歪",
    pronunciation: "wāi",
    meaning: "不正，斜，偏年画挂",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2235",
    type: "character",
    title: "粘",
    content: "粘",
    pronunciation: "zhān",
    meaning: "像胶水或浆糊的性质",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2236",
    type: "character",
    title: "柄",
    content: "柄",
    pronunciation: "bǐnɡ",
    meaning: "又如柄子(方言。器物的把儿);刀柄;勺柄;曲柄(曲轴的弯曲部",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2237",
    type: "character",
    title: "坑",
    content: "坑",
    pronunciation: "kēnɡ",
    meaning: "凹下去的地方挖个",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2238",
    type: "character",
    title: "陌",
    content: "陌",
    pronunciation: "mò",
    meaning: "田间的小路，南北为\"阡\"，东西为\"陌\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2239",
    type: "character",
    title: "窄",
    content: "窄",
    pronunciation: "zhǎi",
    meaning: "横的距离小，跟\"宽\"相对狭",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2240",
    type: "character",
    title: "湘",
    content: "湘",
    pronunciation: "xiānɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2241",
    type: "character",
    title: "兆",
    content: "兆",
    pronunciation: "zhào",
    meaning: "数目字百万为",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2242",
    type: "character",
    title: "崖",
    content: "崖",
    pronunciation: "yá",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2243",
    type: "character",
    title: "骄",
    content: "骄",
    pronunciation: "jiāo",
    meaning: "马高大健壮的样子四牡有",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2244",
    type: "character",
    title: "刹",
    content: "刹",
    pronunciation: "shā",
    meaning: "止住，使停止急",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2245",
    type: "character",
    title: "鞭",
    content: "鞭",
    pronunciation: "biān",
    meaning: "又如鞭影(马鞭的影子◇以比喻警戒策勉);鞭镫(马鞭与马镫);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2246",
    type: "character",
    title: "芒",
    content: "芒",
    pronunciation: "mánɡ",
    meaning: "铓máng",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2247",
    type: "character",
    title: "筋",
    content: "筋",
    pronunciation: "jīn",
    meaning: "肌腱或附着在骨上的韧带伤及",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2248",
    type: "character",
    title: "聘",
    content: "聘",
    pronunciation: "pìn",
    meaning: "招请，请人担任工作",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2249",
    type: "character",
    title: "钩",
    content: "钩",
    pronunciation: "ɡōu",
    meaning: "弯曲的器具，用于悬挂或探取东西等火",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2250",
    type: "character",
    title: "棍",
    content: "棍",
    pronunciation: "ɡùn",
    meaning: "棒木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2251",
    type: "character",
    title: "嚷",
    content: "嚷",
    pronunciation: "rǎnɡ",
    meaning: "谁在那儿嚷嚷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2252",
    type: "character",
    title: "腺",
    content: "腺",
    pronunciation: "xiàn",
    meaning: "生物体内能分泌某些化学物质的组织",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2253",
    type: "character",
    title: "弦",
    content: "弦",
    pronunciation: "xián",
    meaning: "弯弓上发箭的绳，一般用牛筋制成弓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2254",
    type: "character",
    title: "焰",
    content: "焰",
    pronunciation: "yàn",
    meaning: "火苗火",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2255",
    type: "character",
    title: "耍",
    content: "耍",
    pronunciation: "shuǎ",
    meaning: "玩，游戏玩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2256",
    type: "character",
    title: "俯",
    content: "俯",
    pronunciation: "fǔ",
    meaning: "弯腰屈身",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2257",
    type: "character",
    title: "厘",
    content: "厘",
    pronunciation: "lí",
    meaning: "长度单位公制10毫米为1",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2258",
    type: "character",
    title: "愣",
    content: "愣",
    pronunciation: "lènɡ",
    meaning: "发呆，失神发",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2259",
    type: "character",
    title: "厦",
    content: "厦",
    pronunciation: "shà",
    meaning: "厦门市，在福建省",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2260",
    type: "character",
    title: "恳",
    content: "恳",
    pronunciation: "kěn",
    meaning: "请求,表露愿望和要求",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2261",
    type: "character",
    title: "饶",
    content: "饶",
    pronunciation: "ráo",
    meaning: "多，富足",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2262",
    type: "character",
    title: "钉",
    content: "钉",
    pronunciation: "dìnɡ",
    meaning: "又如钉铰(一种金属零件。凡刀柄鞍首等皆有此);钉靴(鞋底钉钉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2263",
    type: "character",
    title: "寡",
    content: "寡",
    pronunciation: "ɡuǎ",
    meaning: "少;缺少",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2264",
    type: "character",
    title: "憾",
    content: "憾",
    pronunciation: "hàn",
    meaning: "同本义(先秦古书一般用憾,汉代以后多用恨)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2265",
    type: "character",
    title: "摔",
    content: "摔",
    pronunciation: "shuāi",
    meaning: "用力扔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2266",
    type: "character",
    title: "叠",
    content: "叠",
    pronunciation: "dié",
    meaning: "折,折叠,交叠,指用对折或交叠的方法减少长度或宽度",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2267",
    type: "character",
    title: "惹",
    content: "惹",
    pronunciation: "rě",
    meaning: "又如惹口面(惹麻烦);惹邪(魅人);惹起(引起);惹口舌(引",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2268",
    type: "character",
    title: "喻",
    content: "喻",
    pronunciation: "yù",
    meaning: "比方比",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2269",
    type: "character",
    title: "谱",
    content: "谱",
    pronunciation: "pǔ",
    meaning: "记载事物类别、系统等的表册或书籍菜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2270",
    type: "character",
    title: "愧",
    content: "愧",
    pronunciation: "kuì",
    meaning: "同本义。同媿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2271",
    type: "character",
    title: "煌",
    content: "煌",
    pronunciation: "huánɡ",
    meaning: "明亮辉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2272",
    type: "character",
    title: "徽",
    content: "徽",
    pronunciation: "huī",
    meaning: "标志，符号",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2273",
    type: "character",
    title: "溶",
    content: "溶",
    pronunciation: "rónɡ",
    meaning: "物体在水或其它液体里化开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2274",
    type: "character",
    title: "坠",
    content: "坠",
    pronunciation: "zhuì",
    meaning: "落，掉下，下沉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2275",
    type: "character",
    title: "煞",
    content: "煞",
    pronunciation: "shà",
    meaning: "同\"杀",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2276",
    type: "character",
    title: "巾",
    content: "巾",
    pronunciation: "jīn",
    meaning: "缠束或覆盖用的织物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2277",
    type: "character",
    title: "滥",
    content: "滥",
    pronunciation: "làn",
    meaning: "大水漫溢泛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2278",
    type: "character",
    title: "洒",
    content: "洒",
    pronunciation: "sǎ",
    meaning: "液体散落先",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2279",
    type: "character",
    title: "堵",
    content: "堵",
    pronunciation: "dǔ",
    meaning: "又如堵墙(墙垣,土墙。用来比喻密集的人群);堵垣(墙)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2280",
    type: "character",
    title: "瓷",
    content: "瓷",
    pronunciation: "cí",
    meaning: "又如瓷碗;细瓷;瓷枕;瓷仙(瓷器的人物造像);瓷注(陶瓷茶壶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2281",
    type: "character",
    title: "咒",
    content: "咒",
    pronunciation: "zhòu",
    meaning: "某些宗教或巫术的密语或符号",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2282",
    type: "character",
    title: "姨",
    content: "姨",
    pronunciation: "yí",
    meaning: "妻的姐妹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2283",
    type: "character",
    title: "棒",
    content: "棒",
    pronunciation: "bànɡ",
    meaning: "又如棒糖;棍棒;棒打鸳鸯(以强硬手段,破坏他人的夫妇关系,或",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2284",
    type: "character",
    title: "郡",
    content: "郡",
    pronunciation: "jùn",
    meaning: "自郡城走数十里。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2285",
    type: "character",
    title: "浴",
    content: "浴",
    pronunciation: "yù",
    meaning: "又如沐浴(洗澡;比喻受润泽);浴渪(洗澡);淋浴(喷水洗澡)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2286",
    type: "character",
    title: "媚",
    content: "媚",
    pronunciation: "mèi",
    meaning: "美好，可爱妩",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2287",
    type: "character",
    title: "稣",
    content: "稣",
    pronunciation: "sū",
    meaning: "转意为死而复生,苏醒,复活。今作苏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2288",
    type: "character",
    title: "淮",
    content: "淮",
    pronunciation: "huái",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2289",
    type: "character",
    title: "哎",
    content: "哎",
    pronunciation: "āi",
    meaning: "表示满意或赞叹 。如哎,这就对了!",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2290",
    type: "character",
    title: "屁",
    content: "屁",
    pronunciation: "pì",
    meaning: "肠道产生但从肛门突然排出的臭气",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2291",
    type: "character",
    title: "漆",
    content: "漆",
    pronunciation: "qī",
    meaning: "同本义。古水名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2292",
    type: "character",
    title: "淫",
    content: "淫",
    pronunciation: "yín",
    meaning: "媓）yín",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2293",
    type: "character",
    title: "巢",
    content: "巢",
    pronunciation: "cháo",
    meaning: "又泛指其他动 物的巢穴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2294",
    type: "character",
    title: "吩",
    content: "吩",
    pronunciation: "fēn",
    meaning: "张大爷吩咐我好生照看小马驹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2295",
    type: "character",
    title: "撰",
    content: "撰",
    pronunciation: "zhuàn",
    meaning: "又如撰具(编成);撰定(编定;写定);撰造(创作;编制)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2296",
    type: "character",
    title: "啸",
    content: "啸",
    pronunciation: "xiào",
    meaning: "打口哨，撮口发音仰天长",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2297",
    type: "character",
    title: "滞",
    content: "滞",
    pronunciation: "zhì",
    meaning: "积压。长期积存,未作处理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2298",
    type: "character",
    title: "玫",
    content: "玫",
    pronunciation: "méi",
    meaning: "该种植物的花",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2299",
    type: "character",
    title: "硕",
    content: "硕",
    pronunciation: "shuò",
    meaning: "引申为大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2300",
    type: "character",
    title: "钓",
    content: "钓",
    pronunciation: "diào",
    meaning: "又如钓蛤蟆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-2301",
    type: "character",
    title: "蝶",
    content: "蝶",
    pronunciation: "dié",
    meaning: "身影);蝶戏(谓蝴蝶飞舞嬉戏);蝶意莺情(比喻爱恋春色的情意",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  }
];
